/*
Shopify Checkout2.0 Functions
Made by Datora GmbH & Co. KG
 ____    ______  ______  _____   ____    ______     
/\  _`\ /\  _  \/\__  _\/\  __`\/\  _`\ /\  _  \    
\ \ \/\ \ \ \L\ \/_/\ \/\ \ \/\ \ \ \L\ \ \ \L\ \   
 \ \ \ \ \ \  __ \ \ \ \ \ \ \ \ \ \ ,  /\ \  __ \  
  \ \ \_\ \ \ \/\ \ \ \ \ \ \ \_\ \ \ \\ \\ \ \/\ \ 
   \ \____/\ \_\ \_\ \ \_\ \ \_____\ \_\ \_\ \_\ \_\
    \/___/  \/_/\/_/  \/_/  \/_____/\/_/\/ /\/_/\/_/
*/

const co2 = (function () {
  let client,
    inflCodes = [],
    campaignCodes = [],
    appCodes = [],
    // Eigene Order-Codes, als Set: analyzeCart ruft .has() darauf auf.
    orderCodes = new Set(),
    // Codes, die Shopify im abgeschlossenen Warenkorb als applicable meldet.
    appliedCodes = new Set(),
    campaigns = [],
    shippingRates,
    cartLevelCode = undefined,
    productLevelCode = undefined,
    productLevelType = undefined,
    allCodes = undefined,
    discountCodesAttribute = null,
    market,
    marketHandleId,
    currency,
    countryCode,
    initPromise = null,
    addCodePromise = null,
    updatePromise = null,
    cartInitPromise = null,
    timeDiff = 0,
    settings,
    launchCode,
    influencerCodePriority = false,
    orderDiscountExclusions = false,
    tagsByProductId = new Map(),
    discountTokens = [],
    cartToken,
    // Warenkorb aus der letzten /cart/update.js-Antwort.
    lastUpdateCart = null,
    // Nur gesetzt, solange init() co2.afterCartAttributeChange ausliefert (siehe cartInitCaller).
    handoffCart = null;


  async function clientFetchWithRetry(query, options, retry = true) {
    try {
      return await client.fetch(query, options);

    } catch (error) {
      if (retry) {
        console.warn('[co2] Network error, retrying once...', error);

        client = window.reinitClient();

        return clientFetchWithRetry(query, options, false);
      }

      throw error;
    }
  }

  const bdl = (function () {
    let productsAll = new Map(),
      variantsAll = new Map(),
      bundleDataPromise = null,
      collectionBundleData = null;

    function loadBundlesConfig() {
      const parsed = {};
      const bundleDataElement = document.getElementById('bundle-configuration')?.textContent || '';
      const bundleData = JSON.parse(bundleDataElement || '{}');

      for (const key of Object.keys(bundleData)) {
        parsed[key] = bundleData[key].data;
      }

      return parsed;
    }

    async function ensureBundlePromises() {
      if (!bundleDataPromise) {
        bundleDataPromise = loadBundleData();
      }
      return bundleDataPromise;
    }

    async function bundleDataForCollectionProduct(productId) {
      return collectionBundleData.find((bundle) => bundle.id === productId.toString());
    }

    async function loadBundleData() {
      return new Promise(async (resolve, reject) => {
        const bundles = loadBundlesConfig();

        let productIds = [];

        for (const key of Object.keys(bundles)) {
          const bundle = bundles[key];
          if (bundle) {
            for (const productArray of bundle.products) {
              for (const product of productArray) {
                productIds.push(product.pid);
              }
            }
          }
        }
        productIds = Array.from(new Set(productIds));

        const query = `query Products($ids: [ID!]!, $country: CountryCode) @inContext(country: $country) {
          nodes(ids: $ids) {
            ... on Product {
              id
              handle
              tags
              availableForSale
              soldout_markets: metafield(key: "soldout-markets", namespace: "mn_system") {
                key
                value
              }
              variants(first: 100) {
                nodes {
                  id
                  title
                  price {
                    amount
                  }
                  availableForSale
                  metafields(
                    identifiers: [
                      {key: "soldout-markets", namespace: "mn_system"},
                      {key: "size_option_value_id", namespace: "mn_system"}
                    ]
                  ) {
                    namespace
                    key
                    value
                  }
                }
              }
            }
          }
        }`;

        const variables = {
          ids: productIds.map((id) => `gid://shopify/Product/${id}`),
          country: countryCode,
        };
        let data, errors, extensions;

        try {
          const response = await clientFetchWithRetry(query, { variables });
          if (!response.ok) {
            throw new Error(`Netzwerk meldet Fehler. Status: ${response.status}, Status-Text: ${response.statusText}`);
          }
          ({ errors, data, extensions } = await response.json());
          const serverTime = response.headers.get('Date');
          if (serverTime) {
            const serverDate = new Date(serverTime);
            const clientDate = new Date();
            timeDiff = serverDate - clientDate;
          }
          // console.log("data", data);
        } catch (error) {
          console.error('Fehler beim Laden der Bundle-Produkte');
          console.error(error);
        }
        createProductData(data);
        collectionBundleData = createBundleData(bundles);
        resolve();
      });
    }

    function createBundleData(bundleData) {
      const bundleDataArray = [];
      let bundleAvailable, bundlePrice;
      for (const bundleId of Object.keys(bundleData)) {
        const bundle = bundleData[bundleId];

        bundleAvailable = true;
        bundlePrice = 0;
        if (!bundle?.products || bundle?.products.length === 0) {
          console.warn(`Bundle ${bundleId} has no products defined.`);
          continue;
        }

        for (const productArray of bundle.products) {
          let productArrayAvail = false;
          const productArrayPrices = [];

          for (const product of productArray) {
            let productAvailable = false;
            let productPrice = Infinity;
            let productPriceAvail = Infinity;

            if (productsAll.has(product.pid)) {
              if (
                product.def_vid > 0 &&
                variantsAll.has(product.def_vid) &&
                variantsAll.get(product.def_vid).available
              ) {
                productAvailable = true;
                const price = variantsAll.get(product.def_vid).price;
                productPrice = price < productPrice ? price : productPrice;
                productPriceAvail = productPrice;
              } else {
                if (product.base == 'vars') {
                  for (const vid of product.vids) {
                    if (variantsAll.has(vid)) {
                      const variant = variantsAll.get(vid);
                      const price = variant.price;
                      productPrice = price < productPrice ? price : productPrice;
                      if (variant.available) {
                        productAvailable = true;
                        productPriceAvail = price < productPriceAvail ? price : productPriceAvail;
                      }
                    }
                  }
                } else {
                  // base == "prods"
                  if (product.option_value_id && product.size_option_index >= 0) {
                    for (const variant of productsAll.get(product.pid).variants) {
                      if (variant.sizeOptionValueId === product.option_value_id) {
                        const price = variant.price;
                        productPrice = price < productPrice ? price : productPrice;
                        if (variant.available) {
                          productAvailable = true;
                          productPriceAvail = price < productPriceAvail ? price : productPriceAvail;
                        }
                      }
                    }
                  } else {
                    const prod = productsAll.get(product.pid);
                    const price = prod.price;
                    productPrice = price < productPrice ? price : productPrice;
                    productAvailable = prod.available;
                    if (prod.available) {
                      productPriceAvail = price < productPriceAvail ? price : productPriceAvail;
                    }
                  }
                }
              }
            }
            // Infinity will happen if product is not found in the product data
            // Note, that productAvailable is false if product is not found
            productPrice = productPrice === Infinity ? 0 : productPrice;
            productPriceAvail = productPriceAvail === Infinity ? 0 : productPriceAvail;
            if (!productAvailable) {
              productArrayPrices.push({
                price: productPrice,
                available: false,
              });
            } else {
              productArrayAvail = true;
              productArrayPrices.push({
                price: productPriceAvail,
                available: true,
              });
            }
          }
          if (!productArrayAvail) {
            bundleAvailable = false;
            // Pick the first, not the minimum price
            //const minPrice = productArrayPrices
            //  .reduce((min, p) => p.price < min ? p.price : min, Infinity);
            //bundlePrice += minPrice;
            const price = productArrayPrices[0].price;
            bundlePrice += price;
          } else {
            // Pick the first, not the minimum price
            //const minPrice = productArrayPrices
            //  .filter(p => p.available)
            //  .reduce((min, p) => p.price < min ? p.price : min, Infinity);
            // bundlePrice += minPrice;
            const price = productArrayPrices.filter((p) => p.available)[0].price;
            bundlePrice += price;
          }
        }

        bundleDataArray.push({
          id: bundleId,
          calc: bundle.calc,
          discountAmount: bundle.disc_amt[currency] ?? 0,
          discountPercent: bundle.disc_perc ?? 0,
          available: bundleAvailable,
          price: bundlePrice,
          bundleDiscPrice: bundleDiscount(bundle, bundlePrice),
        });
      }
      return bundleDataArray;
    }

    function bundleDiscount(bundle, price) {
      return calculate(price, bundle.calc, bundle.disc_perc, bundle.disc_amt[currency] ?? 0, 1);
    }

    function createProductData(data) {
      //const ts = new Date();
      productsAll.clear();
      variantsAll.clear();

      for (const product of data.nodes) {
        if (product === null) {
          continue;
        }
        let productIsAvailable = true;
        let productMinPrice = Infinity;
        let productMinPriceAvail = Infinity;
        if (!productAvailable(product)) {
          productIsAvailable = false;
        }

        const productData = {
          id: numericId(product.id),
          handle: product.handle,
          available: null,
          price: Infinity,
          priceAvail: Infinity,
          variants: [],
        };

        let hasAvailableVariants = false;
        for (const variant of product.variants.nodes) {
          let variantIsAvailable = productIsAvailable;
          if (!variantAvailable(variant)) {
            variantIsAvailable = false;
          }
          if (variantIsAvailable) {
            hasAvailableVariants = true;
          }

          const sizeOptionValueId =
            variant.metafields
              .find((metafield) => metafield?.key === 'size_option_value_id')
              ?.value.split('/')
              .pop() || null;
          const variantData = {
            id: numericId(variant.id),
            title: variant.title,
            available: variantIsAvailable,
            price: round(parseFloat(variant.price.amount) * 100),
            sizeOptionValueId: sizeOptionValueId ? parseInt(sizeOptionValueId, 10) : null,
          };

          if (productIsAvailable && variantIsAvailable) {
            productMinPriceAvail = variantData.price < productMinPriceAvail ? variantData.price : productMinPriceAvail;
          }
          productMinPrice = variantData.price < productMinPrice ? variantData.price : productMinPrice;

          variantsAll.set(numericId(variant.id), variantData);
          productData.variants.push(variantData);
        }
        productData.available = productIsAvailable && hasAvailableVariants;
        productData.price = productMinPrice;
        productData.priceAvail = productMinPriceAvail;
        productsAll.set(numericId(product.id), productData);
      }

      //console.log("Time to create free product data: ", new Date() - ts);
    }

    return {
      ensureBundlePromises,
      bundleDataForCollectionProduct,
    };
  })();

  const calc = (function () {
    let applicableProductDiscounts = [],
      standardProductDiscounts = [],
      standardDiscountCode,
      standardDiscRules = [],
      applicableShippingDiscounts = [],
      discRules = [],
      freeProductIds,
      freeProductRules = [],
      sortedPerc = false,
      condDiscRulesT = [],
      condDiscRulesQ = [],
      standardCondDiscRulesT = [],
      standardCondDiscRulesQ = [],
      shippingRules = [],
      standardExTags,
      disc_ex_tags,
      fp_thresh_ex_tags,
      cdg_thresh_ex_tags,
      ship_thresh_ex_tags,
      lines,
      condDiscCandidates = [],
      freeProductCandidates = [],
      freeProducts = [],
      freeProductData = [],
      freeProductThresholds = [],
      sub_total,
      ship_sub_total,
      freeProductHandles = new Map(),
      availableFreeProducts = new Set(),
      availableFreeProductVariants = new Set(),
      variantProductMap = new Map(),
      productVariantMap = new Map(),
      productTags,
      freeShipBySuppCode,
      suppressFreeProducts,
      variantTagsByVariantId = new Map(),
      variantSaleByVariantId = new Map();

    async function init(cart = null) {
      applicableProductDiscounts = campaigns.product_discounts.filter((camp) => campaignApplicable(camp));

      standardProductDiscounts = campaigns.product_discounts.filter((camp) => standardCampaign(camp));
      standardDiscountCode = standardProductDiscounts.length > 0 ? launchCode : null;

      applicableShippingDiscounts = campaigns.shipping_discounts.filter((camp) => shippingCampaignApplicable(camp));

      freeProductIds = applicableProductDiscounts.flatMap((camp) =>
        camp.fp_active
          ? camp.fp.flatMap((f) => {
              if (f.base == 'prods') {
                return f.product_items;
              } else if (f.base == 'vars') {
                return f.product_variant_items.map((pvi) => pvi.pid);
              } else {
                return [];
              }
            })
          : [],
      );
      freeProductIds = Array.from(new Set(freeProductIds));

      let data;
      if (freeProductIds.length > 0) {
        const query = `query Products($ids: [ID!]!, $country: CountryCode) @inContext(country: $country) {
          nodes(ids: $ids) {
            ... on Product {
              id
              title
              handle
              productType
              tags
              featuredImage {
                url
              }
              availableForSale
              soldout_markets: metafield(key: "soldout-markets", namespace: "mn_system") {
                key
                value
              }
              variants(first: 100) {
                nodes {
                  id
                  title
                  price {
                    amount
                  }
                  compareAtPrice {
                    amount
                  }
                  image {
                    url
                  }
                  availableForSale
                  metafield(key: "generic_tags", namespace: "pim") {
                    value
                  }
                  metafields(
                    identifiers: [
                      {key: "soldout-markets", namespace: "mn_system"},
                      {key: "units_per_item", namespace: "mn_deposit"},
                      {key: "variant_item", namespace: "mn_deposit"}
                    ]
                  ) {
                    namespace
                    key
                    value
                  }
                }
              }
            }
          }
        }`;

        const variables = {
          ids: freeProductIds.map((id) => `gid://shopify/Product/${id}`),
          country: countryCode,
        };
        let errors, extensions;

        try {
          const response = await clientFetchWithRetry(query, { variables });
          if (!response.ok) {
            throw new Error(`Netzwerk meldet Fehler. Status: ${response.status}, Status-Text: ${response.statusText}`);
          }
          ({ errors, data, extensions } = await response.json());
          const serverTime = response.headers.get('Date');
          if (serverTime) {
            const serverDate = new Date(serverTime);
            const clientDate = new Date();
            timeDiff = serverDate - clientDate;
          }
        } catch (error) {
          console.error(error);
          throw new Error('Fehler beim Laden der Free Products');
        }
      } else {
        data = { nodes: [] };
      }

      freeProductHandles.clear();
      for (const node of data.nodes) {
        if (node !== null) {
          freeProductHandles.set(numericId(node.id), node.handle);
          for (const variant of node.variants.nodes) {
            const raw = variant.metafield?.value || '[]';
            let arr;
            try {
              arr = JSON.parse(raw);
            } catch {
              arr = [];
            }
            variantTagsByVariantId.set(numericId(variant.id), new Set(arr.map((t) => t.toLowerCase())));
            const priceAmt = parseFloat(variant.price?.amount ?? '0');
            const compareAmt = parseFloat(variant.compareAtPrice?.amount ?? '0');
            variantSaleByVariantId.set(
              numericId(variant.id),
              Number.isFinite(priceAmt) && Number.isFinite(compareAmt) && compareAmt > priceAmt,
            );
          }
        }
      }

      standardExTags = new Set();
      disc_ex_tags = new Set();
      fp_thresh_ex_tags = new Set();
      cdg_thresh_ex_tags = new Set();
      ship_thresh_ex_tags = new Set();

      for (const camp of applicableProductDiscounts) {
        disc_ex_tags = new Set([...disc_ex_tags, ...camp.disc_ex_tags]);
        fp_thresh_ex_tags = new Set([...fp_thresh_ex_tags, ...camp.fp_thresh_ex_tags]);
        cdg_thresh_ex_tags = new Set([...cdg_thresh_ex_tags, ...camp.cdg_thresh_ex_tags]);
      }

      for (const camp of standardProductDiscounts) {
        standardExTags = new Set([...standardExTags, ...camp.disc_ex_tags]);
      }

      for (const camp of applicableShippingDiscounts) {
        ship_thresh_ex_tags = new Set([...ship_thresh_ex_tags, ...camp.exTags]);
      }

      discRules = createDiscRules(applicableProductDiscounts, productLevelCode, productLevelType, discountTokens);
      standardDiscRules = createDiscRules(standardProductDiscounts, standardDiscountCode, 'pub', discountTokens);
      sortedPerc = sortedPercRules();
      createFreeProductRules();
      createFreeProductThresholds();
      createFreeProductData(data);
      createCondDiscRules();
      createCondDiscRules(standardProductDiscounts, standardDiscountCode, 'pub', standardCondDiscRulesQ, standardCondDiscRulesT);
      createShippingRules();
      try {
        await cartInit(cart);
      } catch (error) {
        console.error(error);
        throw new Error('Fehler beim Initialisieren des Warenkorbs');
      }
      window.removeEventListener('cart.update', cartInitCaller);
      window.addEventListener('cart.update', cartInitCaller);
    }

    function cartInitCaller(event) {
      // global.js beantwortet co2.afterCartAttributeChange synchron mit cart.update ohne Warenkorb. Trifft das
      // Ereignis noch während dieser Auslieferung ein, gilt der eben aus /cart/update.js erhaltene Stand: eine
      // neuere Änderung kann synchron nicht angekommen sein. Danach ist handoffCart null und cartInit lädt selbst.
      cartInit(event.detail?.cart ?? handoffCart, refreshCodes);
    }

    async function cartInit(cart = null, refreshFn = null) {
      if (cartInitPromise) {
        await cartInitPromise;
      }

      let resolveFn, rejectFn;
      cartInitPromise = new Promise((resolve, reject) => {
        resolveFn = resolve;
        rejectFn = reject;
      });

      (async () => {
        try {
          sub_total = 0;
          ship_sub_total = 0;
          freeShipBySuppCode = false;
          freeProducts = [];
          condDiscCandidates = [];
          freeProductCandidates = [];
          suppressFreeProducts = false;
          productTags = new Set();

          for (const rule of condDiscRulesQ) {
            rule.cond_count = 0;
            rule.count = 0;
          }
          for (const rule of condDiscRulesT) {
            rule.cond_sub_total = 0;
            rule.count = 0;
          }
          for (const rule of standardCondDiscRulesQ) {
            rule.cond_count = 0;
            rule.count = 0;
          }
          for (const rule of standardCondDiscRulesT) {
            rule.cond_sub_total = 0;
            rule.count = 0;
          }
          for (const rule of freeProductRules) {
            rule.count = 0;
            rule.trig_count = 0;
          }

          // Ausschnitte (z. B. add.js-Antworten) nachladen; ein leerer Warenkorb mit total_price 0 ist vollständig.
          if (!isFullCart(cart)) {
            try {
              const response = await fetch(window.Shopify.routes.root + 'cart.js');
              if (!response.ok) {
                throw new Error(`Network error. Status: ${response.status}, status text: ${response.statusText}`);
              }
              cart = await response.json();
            } catch (error) {
              console.error('Fehler beim Laden des Warenkorbs:', error);
              throw new Error('Error loading cart');
            }
          }
          // Refresh auf Cart Token
          cartToken = cart.token;

          if (refreshFn) {
            refreshFn(cart);
          }
          await createLines(cart);

          for (const line of lines) {
            // Free shipping from a support-code line.
            if (
              line.properties['_free_product_code'] != null &&
              line.properties['_extra'] == 'freeshipping' &&
              applicableShippingDiscounts.length > 0
            ) {
              freeShipBySuppCode = true;
            }

            const discount = campaignDiscount(line, discRules, disc_ex_tags, true);
            const price_per_unit = round(discount.discPrice / line.quantity);

            if (line.disc_price != discount.discPrice && condDiscCandidate(line)) {
              condDiscCandidates.push({
                line,
                price_per_unit,
                calc: discount.calc,
                discPerc: discount.discPerc,
                discAmt: discount.discAmt,
                discPrice: discount.discPrice,
                count: 0,
              });
            } else if (line.disc_price == 0 && line.sub_total > 0 && freeProductCandidate(line)) {
              freeProductCandidates.push({
                line,
                price_per_unit,
                calc: discount.calc,
                discPerc: discount.discPerc,
                discAmt: discount.discAmt,
                discPrice: discount.discPrice,
                count: 0,
              });
            }

            if (!tagIntersection(line.tags, fp_thresh_ex_tags)) {
              sub_total += line.disc_price;
            }

            if (!tagIntersection(line.tags, ship_thresh_ex_tags)) {
              ship_sub_total += line.disc_price;
            }

            if (tagIntersection(line.tags, fp_thresh_ex_tags) && tagIntersection(line.tags, new Set(['onlythis']))) {
              suppressFreeProducts = true;
            }

            for (const rule of condDiscRulesQ) {
              if (conditionApplies(rule, line) && !line.cond_disc_exclusion) {
                rule.cond_count += line.quantity;
              }
            }

            for (const rule of condDiscRulesT) {
              if (
                conditionApplies(rule, line) &&
                !line.cond_disc_exclusion &&
                !tagIntersection(line.tags, cdg_thresh_ex_tags)
              ) {
                rule.cond_sub_total += line.disc_price;
              }
            }

            for (const rule of standardCondDiscRulesQ) {
              if (conditionApplies(rule, line) && !line.cond_disc_exclusion) {
                rule.cond_count += line.quantity;
              }
            }

            for (const rule of standardCondDiscRulesT) {
              if (
                conditionApplies(rule, line) &&
                !line.cond_disc_exclusion &&
                !tagIntersection(line.tags, cdg_thresh_ex_tags)
              ) {
                rule.cond_sub_total += line.disc_price;
              }
            }

            for (const rule of freeProductRules) {
              if (rule.trigger == 'product' && triggerApplies(rule, line) && !line.cond_disc_exclusion) {
                rule.trig_count += line.quantity;
              }
            }

            productTags = new Set([...productTags, ...line.tags]);
          }

          for (const candidate of condDiscCandidates) {
            for (const ruleSet of [condDiscRulesQ, condDiscRulesT]) {
              for (const rule of ruleSet) {
                if (
                  ruleApplies(rule, candidate.line) &&
                  candidate.line.disc_price ==
                    calculate(candidate.line.sub_total, 'perc', rule.disc_perc, 0, candidate.line.quantity)
                ) {
                  const maxCount = condDiscMaxCount(rule);
                  const i = Math.min(candidate.line.quantity - candidate.count, maxCount - rule.count);
                  if (i > 0) {
                    rule.count += i;
                    candidate.count += i;
                  }
                }
              }
            }
          }

          let i = 0;
          while (i < condDiscCandidates.length) {
            let candidate = condDiscCandidates[i];
            if (
              candidate.count < candidate.line.quantity &&
              freeProductCandidate(candidate.line) &&
              candidate.line.disc_price == 0 &&
              candidate.line.sub_total > 0
            ) {
              const [removedCandidate] = condDiscCandidates.splice(i, 1);
              freeProductCandidates.push(removedCandidate);
            } else {
              i++;
            }
          }

          if (!suppressFreeProducts) {
            for (const rule of freeProductRules) {
              const maxCount = freeProdMaxCount(rule);
              if (maxCount <= 0) {
                continue;
              }
              for (const candidate of freeProductCandidates) {
                const remainingForRule = Math.max(maxCount - rule.count, 0);
                if (remainingForRule <= 0) {
                  continue;
                }
                if (!ruleApplies(rule, candidate.line) || candidate.count >= candidate.line.quantity) {
                  continue;
                }
                const remainingForCandidate = candidate.line.quantity - candidate.count;

                let i = 0;
                if (
                  (rule.trigger == 'threshold' && sub_total >= Math.trunc(rule.threshold * 100)) ||
                  rule.trigger == 'product'
                ) {
                  i = Math.min(remainingForRule, remainingForCandidate);
                }

                if (i > 0) {
                  rule.count += i;
                  candidate.count += i;
                  if (candidate.count == candidate.line.quantity) {
                    freeProducts.push(candidate.line);
                  }
                }
              }
            }
          }

          window.dispatchEvent(new CustomEvent('co2.cart.initialized'));
          resolveFn();
        } catch (error) {
          console.error('Fehler in cartInit:', error);
          rejectFn(error);
        } finally {
          cartInitPromise = null;
        }
      })();

      return cartInitPromise;
    }

    function createDiscRules(productDiscounts, discCode, discType, discTokens) {
      return productDiscounts.flatMap((camp) =>
        camp.dg
          .filter((disc_group) => groupApplicable(disc_group, discCode, discType, discTokens))
          .map((disc_group) => ({
            rule_key: null,
            calc: disc_group.calc,
            purchase_type: disc_group.purchase_type ?? 'once',
            base: disc_group.base,
            tags: new Set(disc_group.tags),
            ex_tags: new Set(disc_group.ex_tags),
            product_ids: new Set(disc_group.product_items),
            variant_ids: new Set(disc_group.product_variant_items.flatMap((pvi) => pvi.vids)),
            use_variant_tags: disc_group.use_variant_tags || false,
            variant_tags: new Set(disc_group.variant_tags || []),
            ex_variant_tags: new Set(disc_group.ex_variant_tags || []),
            disc_amt: disc_group.disc_amt[currency] ?? 0,
            disc_perc: disc_group.disc_perc,
            sale_mode: disc_group.sale_price || 'exclude',
          })),
      );
    }

    function sortedPercRules() {
      if (discRules.find((rule) => rule.calc == 'amt')) {
        return false;
      }
      let lastPerc = 101;
      for (const rule of discRules) {
        if (rule.disc_perc > lastPerc) {
          return false;
        }
        lastPerc = rule.disc_perc;
      }
      return true;
    }

    function createFreeProductRules() {
      freeProductRules = applicableProductDiscounts
        .filter((camp) => camp.fp_active)
        .flatMap((camp) =>
          camp.fp
            .filter(
              (f) =>
                f.quant > 0 &&
                groupApplicable(f, productLevelCode, productLevelType, discountTokens) &&
                (((!f.trigger || f.trigger == 'threshold') &&
                  f.threshold[currency] !== undefined &&
                  f.threshold[currency] >= 0) ||
                  (f.trigger == 'product' && f.trig_quant > 0)),
            )
            .map((f) => ({
              rule_key: f.rule_key,
              trigger: f.trigger || 'threshold',
              trig_quant: f.trig_quant || 0,
              trig_base: f.trig_base || 'prods',
              trig_tags: new Set(f.trig_tags || []),
              trig_ex_tags: new Set(f.trig_ex_tags || []),
              trig_product_ids: new Set(f.trig_product_items || []),
              trig_variant_ids: new Set((f.trig_product_variant_items || []).flatMap((pvi) => pvi.vids)),
              trig_use_variant_tags: f.trig_use_variant_tags || false,
              trig_variant_tags: new Set(f.trig_variant_tags || []),
              trig_ex_variant_tags: new Set(f.trig_ex_variant_tags || []),
              trig_sale_mode: f.trig_sale_price || 'exclude',
              trig_count: 0,
              multi_apply: f.multi_apply || (!f.trigger || f.trigger == 'threshold' ? 'once' : 'multiply'),
              quant: f.quant,
              count: 0,
              purchase_type: 'once',
              base: f.base,
              tags: new Set(f.tags),
              ex_tags: new Set(f.ex_tags),
              product_ids: new Set(f.product_items),
              variant_ids: new Set(f.product_variant_items.flatMap((pvi) => pvi.vids)),
              use_variant_tags: f.use_variant_tags || false,
              variant_tags: new Set(f.variant_tags || []),
              ex_variant_tags: new Set(f.ex_variant_tags || []),
              threshold: f.threshold[currency] ?? 0,
              add_automatically: f.add_automatically,
              sale_mode: f.sale_price || 'exclude',
            })),
        );
    }

    function createFreeProductData(data) {
      //const ts = new Date();
      availableFreeProducts.clear();
      availableFreeProductVariants.clear();
      freeProductData = [];

      for (const product of data.nodes) {
        if (product !== null && productAvailable(product)) {
          let available = false;
          const productData = {
            id: numericId(product.id),
            title: product.title,
            handle: product.handle,
            productType: product.productType,
            image: product.featuredImage?.url,
            hasOnlyDefaultVariant: product.variants.nodes[0].title === 'Default Title',
            variants: [],
          };
          productVariantMap.set(numericId(product.id), new Set());
          for (const variant of product.variants.nodes) {
            if (variantAvailable(variant)) {
              available = true;
              availableFreeProductVariants.add(numericId(variant.id));
              const variantData = {
                id: numericId(variant.id),
                title: variant.title,
                price: round(parseFloat(variant.price.amount) * 100),
                image: variant.image?.url,
                units_per_item: variantUnitsPerItem(variant),
                deposit_variant_id: variantDepositVariantId(variant),
              };
              productData.variants.push(variantData);
              productVariantMap.get(numericId(product.id)).add(variantData.id);
              variantProductMap.set(numericId(variant.id), numericId(product.id));
            }
          }
          if (available) {
            freeProductData.push(productData);
            availableFreeProducts.add(numericId(product.id));
          }
        }
      }
      //console.log("Time to create free product data: ", new Date() - ts);
    }

    function createCondDiscRules(
      campaigns = applicableProductDiscounts,
      code = productLevelCode,
      codeType = productLevelType,
      targetQ = condDiscRulesQ,
      targetT = condDiscRulesT,
    ) {
      targetQ.length = 0;
      targetT.length = 0;
      for (const camp of campaigns) {
        if (camp.cdg_active) {
          for (const cdg of camp.cdg) {
            if (
              groupApplicable(cdg, code, codeType, discountTokens) &&
              cdg.quant > 0 &&
              ((cdg.cond_base == 'prods' && cdg.cond_product_items.length > 0) ||
                (cdg.cond_base == 'vars' && cdg.cond_product_variant_items.length > 0) ||
                (cdg.cond_base == 'tags' && cdg.cond_tags.length > 0)) &&
              ((cdg.cond_minimum == 'quant' && cdg.cond_quant > 0) ||
                (cdg.cond_minimum == 'threshold' &&
                  cdg.cond_threshold[currency] !== undefined &&
                  cdg.cond_threshold[currency] >= 0))
            ) {
              const condDiscRule = {
                rule_key: null,
                quant: cdg.quant,
                count: 0,
                disc_perc: cdg.disc_perc,
                purchase_type: 'once',
                base: cdg.base,
                tags: new Set(cdg.tags),
                ex_tags: new Set(cdg.ex_tags),
                product_ids: new Set(cdg.product_items),
                variant_ids: new Set(cdg.product_variant_items.flatMap((pvi) => pvi.vids)),
                use_variant_tags: cdg.use_variant_tags || false,
                variant_tags: new Set(cdg.variant_tags || []),
                ex_variant_tags: new Set(cdg.ex_variant_tags || []),
                sale_mode: cdg.sale_price || 'exclude',
                multi_apply: cdg.multi_apply,
                cond_base: cdg.cond_base,
                cond_tags: new Set(cdg.cond_tags),
                cond_ex_tags: new Set(cdg.cond_ex_tags),
                cond_product_ids: new Set(cdg.cond_product_items),
                cond_variant_ids: new Set(cdg.cond_product_variant_items.flatMap((pvi) => pvi.vids)),
                cond_use_variant_tags: cdg.cond_use_variant_tags || false,
                cond_variant_tags: new Set(cdg.cond_variant_tags || []),
                cond_ex_variant_tags: new Set(cdg.cond_ex_variant_tags || []),
                cond_sale_mode: cdg.cond_sale_price || 'exclude',
                cond_minimum: cdg.cond_minimum,
                cond_quant: cdg.cond_quant,
                cond_threshold: cdg.cond_threshold[currency] ?? 0,
                cond_count: 0,
                cond_sub_total: 0,
                cond_threshold_used: 0,
                cdg_ref: cdg,
              };
              if (condDiscRule.cond_minimum == 'quant') {
                targetQ.push(condDiscRule);
              } else {
                targetT.push(condDiscRule);
              }
            }
          }
        }
      }
    }

    function createShippingRules() {
      shippingRules = applicableShippingDiscounts
        .filter((camp) => camp.activateEmptyDiscount === false)
        .flatMap((camp) =>
          camp.groups
            .filter((ship_group) => shippingGroupApplicable(ship_group))
            .map((ship_group) => ({
              countries: new Set(ship_group.eligibleCountries),
              product_tags: new Set(ship_group.productTags),
              customer_tags: new Set(ship_group.customerTags),
              threshold: Number.isNaN(parseFloat(ship_group.freeLimit[currency]))
                ? 0
                : parseFloat(ship_group.freeLimit[currency]),
            })),
        );
    }

    async function createLines(cart) {
      const productIds = new Set();
      const variantIds = new Set();
      lines = [];

      for (const item of cart.items) {
        if (!tagsByProductId.has(item.product_id)) {
          productIds.add(item.product_id);
        }
        if (!variantTagsByVariantId.has(item.variant_id)) {
          variantIds.add(item.variant_id);
        }
      }

      if (productIds.size > 0 || variantIds.size > 0) {
      const query = `
        query LinesData($ids: [ID!]!, $country: CountryCode)
        @inContext(country: $country) {
          nodes(ids: $ids) {
            __typename
            ... on Product {
              id
              tags
            }
            ... on ProductVariant {
              id
              metafield(namespace: "pim", key: "generic_tags") {
                value
              }
              price {
                amount
              }
              compareAtPrice {
                amount
              }
            }
          }
        }
      `;

        const variables = {
          ids: [
            ...Array.from(productIds).map((id) => `gid://shopify/Product/${id}`),
            ...Array.from(variantIds).map((id) => `gid://shopify/ProductVariant/${id}`),
          ],
          country: countryCode,
        };
        let data;

        try {
          const response = await clientFetchWithRetry(query, { variables });
          if (!response.ok) {
            throw new Error(`Network error. Status: ${response.status}, status text: ${response.statusText}`);
          }
          ({ data } = await response.json());
        } catch (error) {
          console.error('Fehler beim Laden der Produkt-Tags:', error);
          throw new Error('Error loading product tags');
        }

        for (const node of data.nodes) {
          if (node?.__typename === 'Product') {
            tagsByProductId.set(numericId(node.id), new Set(node.tags));
          } else if (node?.__typename === 'ProductVariant') {
            const raw = node.metafield?.value || '[]';
            let arr;
            try {
              arr = JSON.parse(raw);
            } catch {
              arr = [];
            }
            variantTagsByVariantId.set(numericId(node.id), new Set(arr.map((tag) => tag.toLowerCase())));
            const priceAmt = parseFloat(node.price?.amount ?? '0');
            const compareAmt = parseFloat(node.compareAtPrice?.amount ?? '0');
            variantSaleByVariantId.set(
              numericId(node.id),
              Number.isFinite(priceAmt) && Number.isFinite(compareAmt) && compareAmt > priceAmt,
            );
          }
        }
      }

      lines = cart.items
        .filter((item) => item.quantity > 0)
        .map((item) => ({
          key: item.key,
          product_id: item.product_id,
          variant_id: item.variant_id,
          quantity: item.quantity,
          properties: item.properties,
          sub_total: item.original_line_price,
          disc_price: item.final_line_price,
          price: item.original_price,
          disc_price_per_unit: item.final_price,
          tags: tagsByProductId.get(item.product_id) || new Set(),
          variantTags: variantTagsByVariantId.get(item.variant_id) || new Set(),
          sale_price: variantSaleByVariantId.has(item.variant_id)
            ? !!variantSaleByVariantId.get(item.variant_id)
            : false,
          disc_title:
            item.line_level_discount_allocations.length != 0
              ? item.line_level_discount_allocations[0].discount_application.title
              : '',
          cond_disc_exclusion: item.properties['_gift'] !== undefined,
          subscription: item.selling_plan_allocation?.selling_plan?.recurring_deliveries === true,
          rule_key: item.properties['_gift'] || null,
        }));
    }

    function campaignApplicable(camp) {
      return productLevelCode
        ? camp.markets.includes(market) &&
            ((camp.disc_meth == 'automatic' &&
              ((camp.infl_codes && productLevelType === 'infl') || camp.disc_codes.includes(productLevelCode))) ||
              (camp.disc_meth == 'code' && camp.disc_cd.toLowerCase() == productLevelCode))
        : false;
    }

    function standardCampaign(camp) {
      return (
        camp.markets.includes(market) &&
        camp.disc_meth == 'automatic' &&
        launchCode &&
        camp.disc_codes.includes(launchCode)
      );
    }

    function shippingCampaignApplicable(camp) {
      return !(camp.type_name == 'DiscountCodeApp' && camp.title.toLowerCase() !== productLevelCode);
    }

    function shippingGroupApplicable(ship_group) {
      return (
        ship_group.codeType == '' ||
        (ship_group.codeType == 'infl' && productLevelType == 'infl') ||
        (ship_group.codeType == 'spec' && productLevelCode && ship_group.discCodes?.includes(productLevelCode)) ||
        (ship_group.codeType == 'all' && productLevelCode)
      );
    }

    function groupApplicable(group, discCode, discType, discTokens) {
      const bool =
        ((group.base == 'prods' && group.product_items.length > 0) ||
          (group.base == 'vars' && group.product_variant_items.length > 0) ||
          (group.base == 'tags' && group.tags.length > 0)) &&
        (group.code_application == 'all' ||
          (group.code_application == 'infl' && discType == 'infl') ||
          (group.code_application == 'spec' &&
            discCode &&
            typeof discCode === 'string' &&
            group.specific_codes.includes(discCode))) &&
        (!group.use_tokens || (group.use_tokens && group.disc_tokens.some((token) => discTokens.includes(token))));
      return bool;
    }

    function tagIntersection(tagSet1, tagSet2) {
      if (tagSet1.size == 0 || tagSet2.size == 0) {
        return false;
      }
      for (const tag of tagSet2) {
        if (tagSet1.has(tag)) {
          return true;
        }
      }
      return false;
    }

    function variantTagsMatches(rule, line) {
      if (!rule.use_variant_tags) {
        return true;
      }
      if (tagIntersection(line.variantTags, rule.ex_variant_tags)) {
        return false;
      }
      if (rule.variant_tags.size > 0 && !tagIntersection(line.variantTags, rule.variant_tags)) {
        return false;
      }
      return true;
    }

    function saleModeMatches(mode, isSale) {
      if (!mode || mode === 'include') {
        return true;
      }
      if (mode === 'exclude') {
        return !isSale;
      }
      if (mode === 'only') {
        return isSale;
      }
      return true;
    }

    function saleMatches(rule, line) {
      const mode = rule.sale_mode;
      const isSale = !!line.sale_price;
      return saleModeMatches(mode, isSale);
    }

    function condSaleMatches(rule, line) {
      const mode = rule.cond_sale_mode;
      if (!mode) {
        return true;
      }
      const isSale = !!line.sale_price;
      return saleModeMatches(mode, isSale);
    }

    function trigSaleMatches(rule, line) {
      const mode = rule.trig_sale_mode;
      if (!mode) {
        return true;
      }
      const isSale = !!line.sale_price;
      return saleModeMatches(mode, isSale);
    }

    function productMatches(rule, line) {
      return (
        ((rule.base == 'prods' && rule.product_ids.has(line.product_id)) ||
          (rule.base == 'vars' && rule.variant_ids.has(line.variant_id)) ||
          (rule.base == 'tags' && tagIntersection(line.tags, rule.tags))) &&
        !tagIntersection(line.tags, rule.ex_tags)
      );
    }

    function ruleApplies(rule, line) {
      const ruleKeyMatches = rule.rule_key == null || (line.rule_key != null && line.rule_key === rule.rule_key);

      return (
        ruleKeyMatches &&
        productMatches(rule, line) &&
        purchaseTypeMatches(rule, line) &&
        variantTagsMatches(rule, line) &&
        saleMatches(rule, line)
      );
    }

    function purchaseTypeMatches(rule, line) {
      return (
        (rule.purchase_type == 'once' && !line.subscription) ||
        (rule.purchase_type == 'subscription' && line.subscription) ||
        rule.purchase_type == 'both'
      );
    }

    function conditionApplies(rule, line) {
      return condBaseMatch(rule, line) && condVariantTagsMatch(rule, line) && condSaleMatches(rule, line);
    }

    function condBaseMatch(rule, line) {
      const baseMatch =
        ((rule.cond_base == 'prods' && rule.cond_product_ids.has(line.product_id)) ||
          (rule.cond_base == 'vars' && rule.cond_variant_ids.has(line.variant_id)) ||
          (rule.cond_base == 'tags' && tagIntersection(line.tags, rule.cond_tags))) &&
        !tagIntersection(line.tags, rule.cond_ex_tags);
      return baseMatch;
    }

    function condVariantTagsMatch(rule, line) {
      if (!rule.cond_use_variant_tags) {
        return true;
      }
      if (rule.cond_variant_tags.size > 0 && !tagIntersection(line.variantTags, rule.cond_variant_tags)) {
        return false;
      }
      if (tagIntersection(line.variantTags, rule.cond_ex_variant_tags)) {
        return false;
      }
      return true;
    }

    function triggerApplies(rule, line) {
      return trigBaseMatch(rule, line) && trigVariantTagsMatch(rule, line) && trigSaleMatches(rule, line);
    }

    function trigBaseMatch(rule, line) {
      const baseMatch =
        ((rule.trig_base == 'prods' && rule.trig_product_ids.has(line.product_id)) ||
          (rule.trig_base == 'vars' && rule.trig_variant_ids.has(line.variant_id)) ||
          (rule.trig_base == 'tags' && tagIntersection(line.tags, rule.trig_tags))) &&
        !tagIntersection(line.tags, rule.trig_ex_tags);
      return baseMatch;
    }

    function trigVariantTagsMatch(rule, line) {
      if (!rule.trig_use_variant_tags) {
        return true;
      }
      if (rule.trig_variant_tags.size > 0 && !tagIntersection(line.variantTags, rule.trig_variant_tags)) {
        return false;
      }
      if (tagIntersection(line.variantTags, rule.trig_ex_variant_tags)) {
        return false;
      }
      return true;
    }

    function matchingShippingRules(country, customerTags) {
      return shippingRules.filter(
        (rule) =>
          (rule.countries.size == 0 || rule.countries.has(country)) &&
          (rule.customer_tags.size == 0 || tagIntersection(customerTags, rule.customer_tags)) &&
          (rule.product_tags.size == 0 || tagIntersection(productTags, rule.product_tags)),
      );
    }

    function shippingData(country, customerTags) {
      const standardShipping = shippingRate(country);
      const standardPrice = standardShipping.price;
      const standardThreshold = standardShipping.thresh;
      const rules = matchingShippingRules(country, customerTags);

      let campaignThreshold = null;
      for (const rule of rules) {
        if (!campaignThreshold || rule.threshold < campaignThreshold) {
          campaignThreshold = rule.threshold;
        }
      }

      const freeShipping =
        freeShipBySuppCode ||
        (campaignThreshold !== null && ship_sub_total >= Math.trunc(campaignThreshold * 100)) ||
        (standardThreshold !== null && ship_sub_total >= Math.trunc(standardThreshold * 100));

      return {
        standardPrice: Math.trunc(standardPrice * 100),
        standardThreshold: standardThreshold !== null ? Math.trunc(standardThreshold * 100) : null,
        campaignThreshold: campaignThreshold !== null ? Math.trunc(campaignThreshold * 100) : null,
        sub_total: ship_sub_total,
        freeShipping,
      };
    }

    function shippingRate(country) {
      if (shippingRates[country]) {
        return shippingRates[country];
      } else {
        return shippingRates['DEFAULT'];
      }
    }

    function campaignDiscount(line, rules, ex_tags, useSortedPerc) {
      let zeroDiscount = {
        calc: 'perc',
        discPerc: 0,
        discAmt: 0,
        discPrice: line.sub_total,
      };
      let bestDiscount = zeroDiscount;
      let discount;

      if (tagIntersection(line.tags, ex_tags)) {
        return zeroDiscount;
      }

      for (const rule of rules) {
        if (ruleApplies(rule, line)) {
          discount = calculateDiscount(line, rule);
          if (useSortedPerc && sortedPerc && discount.discPrice < line.sub_total) {
            return discount;
          } else if (discount.discPrice < bestDiscount.discPrice) {
            bestDiscount = discount;
          }
        }
      }

      return bestDiscount;
    }

    function condDiscount(line, discPrice, ruleSets = [condDiscRulesQ, condDiscRulesT]) {
      let zeroDiscount = {
        calc: 'perc',
        discPerc: 0,
        discAmt: 0,
        discPrice: line.sub_total,
      };
      let bestDiscount = zeroDiscount;
      let discount;

      for (const ruleSet of ruleSets) {
        for (const rule of ruleSet) {
          if (ruleApplies(rule, line)) {
            const maxCount = condDiscMaxCount(rule, line, discPrice);
            if (rule.count < maxCount) {
              discount = {
                calc: 'perc',
                discPerc: rule.disc_perc,
                discAmt: 0,
                discPrice: calculate(line.sub_total, 'perc', rule.disc_perc, 0, 1),
              };
              const diff = Math.max(0, discPrice - discount.discPrice);
              if (discount.discPrice < bestDiscount.discPrice && !belowOwnThreshold(rule, discPrice, diff, line)) {
                bestDiscount = discount;
              }
            }
          }
        }
      }
      return bestDiscount;
    }

    // Note: Quantity is always 1
    function newCondDiscThreshold(rule) {
      if (rule.cond_minimum == 'quant') {
        return 0;
      } else {
        if (rule.multi_apply == 'once') {
          return rule.cond_threshold;
        } else if (rule.multi_apply == 'multiply') {
          return Math.trunc((rule.count + rule.quant) / rule.quant) * rule.cond_threshold * 100;
        } else {
          // unlimited
          return rule.cond_threshold;
        }
      }
    }

    function belowOwnThreshold(rule, disc_price, diff, line) {
      return (
        rule.cond_minimum == 'threshold' &&
        conditionApplies(rule, line) &&
        !tagIntersection(line.tags, cdg_thresh_ex_tags) &&
        rule.cond_sub_total + disc_price - diff < newCondDiscThreshold(rule)
      );
    }

    function conditionalDiscounts(line) {
      const rule_applies = [],
        condition_applies = [];

      for (const ruleSet of [condDiscRulesQ, condDiscRulesT]) {
        for (const rule of ruleSet) {
          const item = {
            quant: rule.quant,
            count: rule.count,
            disc_perc: rule.disc_perc,
            base: rule.base,
            tags: rule.cdg_ref.tags,
            ex_tags: rule.cdg_ref.ex_tags,
            product_items: rule.cdg_ref.product_items,
            product_variant_items: rule.cdg_ref.product_variant_items,
            multi_apply: rule.multi_apply,
            cond_base: rule.cond_base,
            cond_tags: rule.cdg_ref.cond_tags,
            cond_ex_tags: rule.cdg_ref.cond_ex_tags,
            cond_product_items: rule.cdg_ref.cond_product_items,
            cond_product_variant_items: rule.cdg_ref.cond_product_variant_items,
            cond_minimum: rule.cond_minimum,
            cond_quant: rule.cond_quant,
            cond_threshold: rule.cond_threshold,
            cond_count: rule.cond_count,
            cond_sub_total: rule.cond_sub_total,
            cond_threshold_used: rule.cond_threshold_used,
            cond_text: rule.cdg_ref.cond_text,
          };
          if (ruleApplies(rule, line)) {
            rule_applies.push(item);
          }
          if (conditionApplies(rule, line)) {
            condition_applies.push(item);
          }
        }
      }
      return { rule_applies, condition_applies };
    }

    function freeProductDiscount(line) {
      for (const rule of freeProductRules) {
        if (
          ruleApplies(rule, line) &&
          rule.count < freeProdMaxCount(rule, line) &&
          (rule.trigger == 'product' || (rule.trigger == 'threshold' && sub_total >= Math.trunc(rule.threshold * 100)))
        ) {
          return {
            calc: 'perc',
            discPerc: 100,
            discAmt: 0,
            discPrice: 0,
          };
        }
      }
      return {
        calc: 'perc',
        discPerc: 0,
        discAmt: 0,
        discPrice: line.sub_total,
      };
    }

    function calculateDiscount(line, discRule) {
      const discPrice = calculate(line.sub_total, discRule.calc, discRule.disc_perc, discRule.disc_amt, line.quantity);
      return {
        calc: discRule.calc,
        discPerc: discRule.disc_perc,
        discAmt: discRule.disc_amt,
        discPrice,
      };
    }

    function maxCondDiscount(line) {
      let maxDiscPerc = 0;
      for (const ruleSet of [condDiscRulesQ, condDiscRulesT]) {
        for (const rule of ruleSet) {
          if (ruleApplies(rule, line)) {
            maxDiscPerc = Math.max(maxDiscPerc, rule.disc_perc);
          }
        }
      }
      return maxDiscPerc;
    }

    function condDiscMaxCount(rule, line = null, discPrice = null) {
      if (rule.cond_minimum == 'quant') {
        let cond_count = rule.cond_count;
        if (line && conditionApplies(rule, line)) {
          cond_count += 1;
        }
        if (cond_count >= rule.cond_quant) {
          if (rule.multi_apply == 'once') {
            return rule.quant;
          } else if (rule.multi_apply == 'multiply') {
            return Math.floor(cond_count / rule.cond_quant) * rule.quant;
          } else {
            // unlimited
            return Infinity;
          }
        }
      } else {
        // threshold
        let cond_sub_total = rule.cond_sub_total;
        if (
          line &&
          discPrice !== null &&
          conditionApplies(rule, line) &&
          !tagIntersection(line.tags, cdg_thresh_ex_tags)
        ) {
          cond_sub_total += discPrice;
        }
        if (cond_sub_total >= Math.trunc(rule.cond_threshold * 100)) {
          if (rule.multi_apply == 'once') {
            return rule.quant;
          } else if (rule.multi_apply == 'multiply') {
            return Math.floor(cond_sub_total / (rule.cond_threshold * 100)) * rule.quant;
          } else {
            // unlimited
            return Infinity;
          }
        }
      }
      return 0;
    }

    function freeProdMaxCount(rule, line = null) {
      if (rule.trigger == 'product') {
        let trig_count = rule.trig_count;
        if (line && triggerApplies(rule, line)) {
          trig_count += 1;
        }
        if (rule.trig_quant > 0 && trig_count >= rule.trig_quant) {
          if (rule.multi_apply == 'once') {
            return rule.quant;
          } else {
            // rule.multi_apply == 'multiply'
            return Math.floor(trig_count / rule.trig_quant) * rule.quant;
          }
        }
      } else {
        // rule.trigger == 'threshold'
        if (sub_total >= Math.trunc(rule.threshold * 100)) {
          return rule.quant;
        }
      }
      return 0;
    }

    function unredeemed(thresh = null) {
      const unredeemedRules = freeProductRules.filter((rule) => {
        if (rule.trigger == 'threshold') {
          if (rule.count >= rule.quant) {
            return false;
          }
          if (thresh) {
            return Math.trunc(rule.threshold * 100) == thresh;
          } else {
            return sub_total >= Math.trunc(rule.threshold * 100);
          }
        } else {
          // rule.trigger == 'product'
          return freeProdMaxCount(rule) > rule.count;
        }
      });

      const unredeemedProducts = [];
      for (const rule of unredeemedRules) {
        const outputBase =
          rule.base === 'prods' && (rule.use_variant_tags || rule.sale_mode !== 'include') ? 'vars' : rule.base;
        const item = {
          rule_key: rule.rule_key,
          trigger: rule.trigger,
          threshold: rule.trigger == 'threshold' ? Math.trunc(rule.threshold * 100) : null,
          sub_total: sub_total,
          unredeemedQty: freeProdMaxCount(rule) - rule.count,
          base: outputBase,
          productItems: [],
          productVariantItems: [],
          addAutomatically: rule.add_automatically,
        };
        if (rule.base == 'prods') {
          for (const product_id of rule.product_ids) {
            const handle = freeProductHandles.get(product_id);
            if (handle && availableFreeProducts.has(product_id)) {
              if (outputBase === 'vars') {
                const vids = productVariantMap.get(product_id) || new Set();
                const eligible = [];
                for (const vid of vids) {
                  if (!availableFreeProductVariants.has(vid)) continue;
                  const isSale = !!variantSaleByVariantId.get(vid);
                  const vtags = variantTagsByVariantId.get(vid) || new Set();
                  if (saleMatches(rule, { sale_price: isSale }) && variantTagsMatches(rule, { variantTags: vtags })) {
                    eligible.push(vid);
                  }
                }
                if (eligible.length > 0) {
                  item.productVariantItems.push({ handle, variant_ids: eligible });
                }
              } else {
                item.productItems.push(handle);
              }
            }
          }
        } else if (rule.base == 'vars') {
          for (const variant_id of rule.variant_ids) {
            const vtags = variantTagsByVariantId.get(variant_id) || new Set();
            if (rule.use_variant_tags && !variantTagsMatches(rule, { variantTags: vtags })) {
              continue;
            }
            const isSale = !!variantSaleByVariantId.get(variant_id);
            if (!saleMatches(rule, { sale_price: isSale })) {
              continue;
            }
            if (availableFreeProductVariants.has(variant_id)) {
              const product_id = variantProductMap.get(variant_id);
              const handle = freeProductHandles.get(product_id);
              if (!handle) continue;
              const itemExisting = item.productVariantItems.find((it) => it.handle == handle);
              if (itemExisting) {
                itemExisting.variant_ids.push(variant_id);
              } else {
                item.productVariantItems.push({
                  handle,
                  variant_ids: [variant_id],
                });
              }
            }
          }
        }
        if (item.productItems.length > 0 || item.productVariantItems.length > 0) {
          unredeemedProducts.push(item);
        }
      }
      return unredeemedProducts;
    }

    function thresholdAvailabilities(getAll) {
      const rules = getAll
        ? freeProductRules.filter((rule) => rule.trigger == 'threshold')
        : freeProductRules.filter(
            (rule) => rule.trigger == 'threshold' && Math.trunc(rule.threshold * 100) <= sub_total,
          );

      const threshItems = new Map();
      for (const rule of rules) {
        const thresh = Math.trunc(rule.threshold * 100);
        if (threshItems.get(thresh) === true) continue;
        if (!threshItems.has(thresh)) {
          threshItems.set(thresh, false);
        }
        if (rule.base == 'prods') {
          for (const product_id of rule.product_ids) {
            if (!availableFreeProducts.has(product_id)) continue;
            const vids = productVariantMap.get(product_id) || new Set();
            for (const vid of vids) {
              if (!availableFreeProductVariants.has(vid)) continue;
              const isSale = !!variantSaleByVariantId.get(vid);
              if (rule.use_variant_tags) {
                const vtags = variantTagsByVariantId.get(vid) || new Set();
                if (!variantTagsMatches(rule, { variantTags: vtags })) continue;
              }
              if (!saleMatches(rule, { sale_price: isSale })) continue;
              threshItems.set(thresh, true);
              break;
            }
            if (threshItems.get(thresh)) break;
          }
        } else if (rule.base == 'vars') {
          for (const variant_id of rule.variant_ids) {
            if (rule.use_variant_tags) {
              const vtags = variantTagsByVariantId.get(variant_id) || new Set();
              if (!variantTagsMatches(rule, { variantTags: vtags })) continue;
            }
            const isSale = !!variantSaleByVariantId.get(variant_id);
            if (!saleMatches(rule, { sale_price: isSale })) continue;
            if (availableFreeProductVariants.has(variant_id)) {
              threshItems.set(thresh, true);
              break;
            }
          }
        }
      }

      const entriesArr = Array.from(threshItems.entries());
      entriesArr.sort((a, b) => a[0] - b[0]);
      return entriesArr.map(([thresh, available]) => ({ thresh, available }));
    }

    function nextFreeProducts() {
      let items;
      const thresh = freeProductThresholds.find((thresh) => {
        if (sub_total >= thresh) return false;
        items = unredeemed(thresh);
        return items.length > 0;
      });
      if (thresh) {
        return {
          threshold: thresh,
          sub_total,
          items,
        };
      }
      return false;
    }

    function condDiscCandidate(line) {
      return !!(
        !line.cond_disc_exclusion &&
        (condDiscRulesQ.find((rule) => ruleApplies(rule, line)) ||
          condDiscRulesT.find((rule) => ruleApplies(rule, line)))
      );
    }

    function freeProductCandidate(line) {
      return !!(
        ((settings.fp_need_cond_disc_exclusion && line.cond_disc_exclusion) || !settings.fp_need_cond_disc_exclusion) &&
        freeProductRules.find((rule) => ruleApplies(rule, line))
      );
    }

    function createFreeProductThresholds() {
      const threshs = freeProductRules
        .filter((rule) => rule.trigger == 'threshold')
        .map((rule) => Math.trunc(rule.threshold * 100));
      freeProductThresholds = [...new Set(threshs.sort((a, b) => a - b))];
    }

    function freeProductKeys() {
      return freeProducts.map((line) => ({
        key: line.key,
        rule_key: line.rule_key || null,
      }));
    }

    return {
      init,
      campaignDiscount,
      condDiscount,
      standardCondDiscRules: () => [standardCondDiscRulesQ, []],
      conditionalDiscounts,
      freeProductDiscount,
      unredeemed,
      nextFreeProducts,
      maxCondDiscount,
      thresholds: () => freeProductThresholds,
      freeProductData: () => freeProductData,
      freeProductKeys,
      thresholdAvailabilities,
      shippingData,
      discRules: () => discRules,
      standardDiscRules: () => standardDiscRules,
      discExTags: () => disc_ex_tags,
      standardExTags: () => standardExTags,
      standardDiscountCode: () => standardDiscountCode,
      suppressFreeProducts: () => suppressFreeProducts,
      standardProductDiscounts: () => standardProductDiscounts,
    };
  })();

  async function ensurePromises() {
    let stabilized = false;

    while (!stabilized) {
      const beforeCartInit = cartInitPromise;
      const beforeUpdate = updatePromise;
      const beforeAddCode = addCodePromise;

      if (!initPromise) {
        initPromise = init();
      }

      const waits = [initPromise];
      if (beforeCartInit) waits.push(beforeCartInit);
      if (beforeUpdate) waits.push(beforeUpdate);
      if (beforeAddCode) waits.push(beforeAddCode);

      await Promise.all(waits);

      const afterCartInit = cartInitPromise;
      const afterUpdate = updatePromise;
      const afterAddCode = addCodePromise;

      const changed =
        (afterCartInit && afterCartInit !== beforeCartInit) ||
        (afterUpdate && afterUpdate !== beforeUpdate) ||
        (afterAddCode && afterAddCode !== beforeAddCode);

      stabilized = !changed;
    }
  }

  function ensureInit() {
    if (!initPromise) {
      initPromise = init();
    }
    return initPromise;
  }

    function parseCampaigns(raw) {
    return {
      product_discounts: (raw.product_discounts || []).map(c => ({
        type_name: c.tn,
        title: c.ti,
        disc_meth: c.dm,
        disc_cd: c.dc,
        infl_codes: c.ic,
        disc_codes: c.dcs || [],
        dg: (c.dg || []).map(g => ({
          code_application: g.ca,
          specific_codes: g.sc || [],
          purchase_type: g.pt,
          calc: g.c,
          base: g.b,
          tags: g.t || [],
          ex_tags: g.xt || [],
          product_items: g.pi || [],
          product_variant_items: g.pvi || [],
          disc_amt: g.da || {},
          disc_perc: g.dp || 0,
          use_tokens: g.ut || false,
          disc_tokens: g.dt || [],
          use_variant_tags: g.uvt || false,
          variant_tags: g.vt || [],
          ex_variant_tags: g.xvt || [],
          sale_price: g.sp,
        })),
        fp_active: c.fp_a,
        fp: (c.fp || []).map(f => ({
          rule_key: f.rk,
          code_application: f.ca,
          specific_codes: f.sc || [],
          trigger: f.tr,
          trig_quant: f.tr_q,
          trig_base: f.tr_b,
          trig_tags: f.tr_t || [],
          trig_ex_tags: f.tr_xt || [],
          trig_product_items: f.tr_pi || [],
          trig_product_variant_items: f.tr_pvi || [],
          trig_use_variant_tags: f.tr_uvt || false,
          trig_variant_tags: f.tr_vt || [],
          trig_ex_variant_tags: f.tr_xvt || [],
          trig_sale_price: f.tr_sp,
          multi_apply: f.ma,
          quant: f.q,
          threshold: f.th || {},
          base: f.b,
          tags: f.t || [],
          ex_tags: f.xt || [],
          product_items: f.pi || [],
          product_variant_items: f.pvi || [],
          add_automatically: f.aa,
          use_tokens: f.ut || false,
          disc_tokens: f.dt || [],
          use_variant_tags: f.uvt || false,
          variant_tags: f.vt || [],
          ex_variant_tags: f.xvt || [],
          sale_price: f.sp,
        })),
        fp_thresh_ex_tags: c.fp_xt || [],
        cdg_active: c.cdg_a,
        cdg: (c.cdg || []).map(g => ({
          code_application: g.ca,
          specific_codes: g.sc || [],
          purchase_type: g.pt,
          quant: g.q,
          disc_perc: g.dp,
          base: g.b,
          tags: g.t || [],
          ex_tags: g.xt || [],
          product_items: g.pi || [],
          product_variant_items: g.pvi || [],
          multi_apply: g.ma,
          cond_base: g.c_b,
          cond_tags: g.c_t || [],
          cond_ex_tags: g.c_xt || [],
          cond_product_items: g.c_pi || [],
          cond_product_variant_items: g.c_pvi || [],
          cond_minimum: g.c_m,
          cond_quant: g.c_q,
          cond_threshold: g.c_th || {},
          cond_text: g.c_tx,
          use_tokens: g.ut || false,
          disc_tokens: g.dt || [],
          use_variant_tags: g.uvt || false,
          variant_tags: g.vt || [],
          ex_variant_tags: g.xvt || [],
          cond_use_variant_tags: g.c_uvt || false,
          cond_variant_tags: g.c_vt || [],
          cond_ex_variant_tags: g.c_xvt || [],
          sale_price: g.sp,
          cond_sale_price: g.c_sp,
        })),
        cdg_thresh_ex_tags: c.cdg_xt || [],
        disc_tags: c.dt || [],
        disc_ex_tags: c.dxt || [],
        markets: c.m || [],
      })),
      shipping_discounts: raw.shipping_discounts || [],
      order_discounts: Array.isArray(raw.order_discounts) ? raw.order_discounts : [],
    };
  }

  // Vollständiger AJAX-Warenkorb (/cart.js, /cart/update.js, /cart/change.js): items-Array und numerische
  // total_price, beim leeren Warenkorb 0. add.js-Antworten (eine Position oder { items } ohne total_price) sind
  // nur ein Ausschnitt — dieselbe Prüfung wie isFullAjaxCart in depositSync (global.js).
  function isFullCart(cart) {
    return Array.isArray(cart?.items) && typeof cart.total_price === 'number';
  }

  // GET /cart.js, den snippets/cart-prefetch.liquid schon im <head> startet. Gilt nur für den ersten init():
  // danach wird er entfernt, spätere Stände kommen über cart.update. init() lädt selbst, wenn er fehlt, keinen
  // vollständigen Warenkorb liefert, nach CART_PREFETCH_TIMEOUT ms noch offen ist oder der Warenkorb seitdem
  // geschrieben wurde.
  const CART_PREFETCH_TIMEOUT = 2000;

  async function takeCartPrefetch() {
    const prefetch = window.MNRCartPrefetch;
    delete window.MNRCartPrefetch;
    if (!prefetch) return null;
    let timer;
    try {
      const cart = await Promise.race([
        prefetch.cart,
        new Promise((resolve) => {
          timer = setTimeout(resolve, CART_PREFETCH_TIMEOUT, null);
        }),
      ]);
      // Erst nach dem Warten prüfen: ein Schreibzugriff, der währenddessen endet, zählt mit.
      return prefetch.isFresh() && isFullCart(cart) ? cart : null;
    } catch (error) {
      return null;
    } finally {
      clearTimeout(timer);
    }
  }

  async function init() {
    return new Promise(async (resolve, reject) => {
      let cart = null;

      try {
        const co2Data = JSON.parse(document.querySelector('#co2_data').text);
        settings = co2Data.settings;
        inflCodes = JSON.parse(base64ToUtf8(co2Data.infl_codes)) || [];
        campaigns = parseCampaigns(
          JSON.parse(base64ToUtf8(co2Data.campaigns)) || {}
        );
        shippingRates = co2Data.standard_shipping_rates;
        market = co2Data.market_handle;
        marketHandleId = co2Data.market_handle_id;
        currency = co2Data.currency_code;
        countryCode = co2Data.country_code;
        launchCode = co2Data.launch_code;
        influencerCodePriority = co2Data.influencer_code_priority === true;
        orderDiscountExclusions = co2Data.order_discount_exclusions === true;
      } catch (error) {
        console.error('Fehler beim Parsen der Daten zur Storefront-Library');
        reject(new Error('Daten zur Storefront-Library konnten nicht geladen werden'));
        return;
      }

      client = window.client;

      inflCodes = new Set(inflCodes.map((code) => code.toLowerCase()));
      for (const product_discount of campaigns.product_discounts) {
        if (product_discount.disc_meth == 'automatic') {
          campaignCodes = campaignCodes.concat(product_discount.disc_codes.map((code) => code.toLowerCase()));
        } else if (product_discount.markets.includes(market)) {
          appCodes.push(product_discount.disc_cd.toLowerCase());
        }
      }
      campaignCodes = new Set(campaignCodes);
      appCodes = new Set(appCodes);
      // dc nicht trimmen: veröffentlicht wird der Admin-Wert, und genau den vergleicht Shopify.
      orderCodes = new Set(
        campaigns.order_discounts
          .filter((discount) => typeof discount?.dc === 'string' && discount.dc !== '')
          .map((discount) => discount.dc.toLowerCase()),
      );

      try {
        cart = await takeCartPrefetch();
        if (!cart) {
          const response = await fetch(window.Shopify.routes.root + 'cart.js');
          if (!response.ok)
            throw new Error(`Netzwerk meldet Fehler. Status: ${response.status}, Status-Text: ${response.statusText}`);
          cart = await response.json();
        }
      } catch (error) {
        console.error(error);
        reject(new Error('Fehler beim Lesen des Warenkorbs'));
        return;
      }

      let { cartLevelCodes, productLevelCodes, hasBook, hasDeposit, applicableCodes } = analyzeCart(cart);
      const { disc_cds, disc_tokens } = getCartAttributes(cart);

      // Ein Rabattlink ersetzt die Codes im Warenkorb; ein verdrängter Code steht danach nur noch im
      // Attribut. Das ist von außen setzbar und landet in einer als HTML gerenderten Meldung.
      const previousCodes = (disc_cds ?? '')
        .split(',')
        .map((entry) => entry.split(':')[0])
        .filter((code) => isAlphanumeric(code));

      const discount_code = getCookieValue('discount_code')?.toLowerCase();
      if (discount_code) {
        // Der Link ersetzt beide Slots, obwohl Produkt- und Warenkorb-Code zusammen gelten dürfen. Nur
        // den Code der anderen Klasse zurückholen — innerhalb einer Klasse gilt weiter "zuletzt gewinnt".
        if (orderCodes.has(discount_code)) {
          const previousProduct = previousCodes.find(
            (code) => campaignCodes.has(code) || appCodes.has(code) || inflCodes.has(code),
          );
          if (previousProduct && !productLevelCodes.includes(previousProduct)) {
            productLevelCodes.push(previousProduct);
          }
        } else if (campaignCodes.has(discount_code) || appCodes.has(discount_code) || inflCodes.has(discount_code)) {
          const previousOrder = previousCodes.find((code) => orderCodes.has(code));
          if (previousOrder && !cartLevelCodes.includes(previousOrder)) {
            cartLevelCodes.push(previousOrder);
          }
        }

        if (influencerCodePriority) {
          const attrInflCode = (disc_cds ?? '')
            .split(',')
            .find((entry) => entry.endsWith(':infl'))
            ?.split(':')[0];

          if (attrInflCode && !inflCodes.has(attrInflCode)) {
            productLevelCodes = productLevelCodes.filter((code) => code !== attrInflCode);
            cartLevelCodes = cartLevelCodes.filter((code) => code !== attrInflCode);
          }

          if (cartLevelCodes.includes(discount_code)) {
            cartLevelCodes = [discount_code];
          } else if (productLevelCodes.includes(discount_code)) {
            if (inflCodes.has(discount_code)) {
              productLevelCodes = [discount_code];
            } else {
              const inflInProduct = productLevelCodes.filter((code) => inflCodes.has(code));
              if (attrInflCode && inflInProduct.includes(attrInflCode)) {
                productLevelCodes = [attrInflCode];
              } else {
                productLevelCodes = [discount_code];
              }
            }
          }
        } else {
          if (cartLevelCodes.includes(discount_code)) {
            cartLevelCodes = [discount_code];
          } else if (productLevelCodes.includes(discount_code)) {
            productLevelCodes = [discount_code];
          }
        }
        deleteCookie('discount_code');
      }
      cartLevelCode = cartLevelCodes.at(-1) ?? null;
      productLevelCode = productLevelCodes.at(-1) ?? null;
      productLevelType = productLevelCode ? (inflCodes.has(productLevelCode) ? 'infl' : 'pub') : null;
      // Nur bei aktivem Schalter und nur für fremde Codes: eigene Order-Codes sind von dieser Storefront-Prüfung ausgenommen.
      if (orderDiscountExclusions && cartLevelCode && (hasBook || hasDeposit) && !orderCodes.has(cartLevelCode)) {
        cartLevelCode = null;
      }
      allCodes = [cartLevelCode, productLevelCode].filter(Boolean).sort();
      appliedCodes = new Set(applicableCodes);
      discountCodesAttribute = getDiscountCodesAttribute(allCodes);
      discountTokens = disc_tokens?.split(',') ?? [];
      cartToken = cart.token;

      if (
        !equal(disc_cds, discountCodesAttribute) ||
        !arraysEqual(allCodes, cart.discount_codes.map((s) => s.code.toLowerCase()).sort())
      ) {
        try {
          await updateCart({ codes: allCodes.join(','), attrib: discountCodesAttribute });
        } catch (error) {
          console.error(error);
          reject(new Error('Fehler beim Aktualisieren des Warenkorbs'));
          return;
        }
        // Den frischen Stand für das synchron folgende cart.update aus global.js bereitstellen (cartInitCaller),
        // sonst lädt cartInit /cart.js ein zweites Mal.
        handoffCart = lastUpdateCart;
        try {
          // Ohne Cookie-Code bleibt das Ereignis nackt: eine gewöhnliche Abstimmung ist keine Eingabe.
          window.dispatchEvent(
            new CustomEvent(
              'co2.afterCartAttributeChange',
              discount_code
                ? {
                    detail: buildOutcome({
                      ok: allCodes.includes(discount_code),
                      entered: discount_code,
                      previousCodes,
                    }),
                  }
                : undefined,
            ),
          );
        } finally {
          handoffCart = null;
        }
      } else {
        try {
          await calc.init(cart);
        } catch (error) {
          console.error(error);
          reject(new Error('Fehler beim Initialisieren auf calc-Ebene'));
          return;
        }
      }

      resolve();
    });
  }

  async function addCode(code) {
    if (addCodePromise) {
      await addCodePromise;
    }

    let resolveFn, rejectFn;
    addCodePromise = new Promise((resolve, reject) => {
      resolveFn = resolve;
      rejectFn = reject;
    });

    (async () => {
      try {
        const lower = code.toLowerCase();
        const previousCodes = [...allCodes];

        const finalize = (ok, error_code = null) =>
          resolveFn(buildOutcome({ ok: ok && allCodes.includes(lower), error_code, entered: lower, previousCodes }));

        const updateCodes = async (codesArray, reInit = true) => {
          const codes = codesArray.sort().join(',');
          const attrib = getDiscountCodesAttribute(codesArray);
          return await updateCart({ codes, attrib, reInit });
        };

        // Bekannte Codes: Kampagne, AppCode, Influencer-Code -> immer productLevelCode
        if (campaignCodes.has(lower) || appCodes.has(lower) || inflCodes.has(lower)) {
          const cartCodes = [lower, cartLevelCode].filter(Boolean);
          await updateCodes(cartCodes);
          return finalize(productLevelCode === lower, 'INVALID');
        }

        // Eigener Order-Code belegt den Warenkorb-Slot ohne Probe: unterhalb seiner Bedingung meldet
        // Shopify applicable: false, die Probe würde ihn verwerfen.
        if (orderCodes.has(lower)) {
          await updateCodes([lower, productLevelCode].filter(Boolean));
          return finalize(cartLevelCode === lower, 'INVALID');
        }

        // Unbekannte Codes: Hinzuzufügen wird versucht
        const cart = await updateCodes([lower, ...allCodes], false);
        const applicable = cart.discount_codes.some((dc) => dc.code.toLowerCase() === lower && dc.applicable);

        // Nicht applicable -> Rücksetzen auf alten Stand und Abbruch
        if (!applicable) {
          await updateCodes(allCodes);
          return finalize(false, 'INVALID');
        }

        // Prüfe, ob productLevelCode oder cartLevelCode
        // applicableCodes bleibt ungelesen: dieser Warenkorb ist der Zwischenstand der Probe.
        const { cartLevelCodes, productLevelCodes, hasBook, hasDeposit } = analyzeCart(cart);

        // productLevelCode -> zusammen mit cartLevelCode setzen
        if (productLevelCodes.includes(lower)) {
          await updateCodes([lower, cartLevelCode].filter(Boolean));
          return finalize(productLevelCode === lower, 'INVALID');
        }

        // cartLevelCode -> bei aktivem Schalter auf Pfand/Buch prüfen -> ggf. rücksetzen
        if (cartLevelCodes.includes(lower)) {
          if (orderDiscountExclusions && (hasBook || hasDeposit)) {
            await updateCodes(allCodes);
            const code = hasBook && hasDeposit ? 'BOOK_AND_DEPOSIT' : hasBook ? 'BOOK' : 'DEPOSIT';
            return finalize(false, code);
          }

          // cartLevelCode gültig -> zusammen mit productLevelCode setzen
          await updateCodes([lower, productLevelCode].filter(Boolean));
          return finalize(cartLevelCode === lower, 'INVALID');
        }

        // Fallback
        finalize(false, 'INVALID');
      } catch (error) {
        console.error('addCode() failed:', error);
        rejectFn(new Error('Fehler beim Aktualisieren des Warenkorbs'));
      } finally {
        addCodePromise = null;
      }
    })();

    return addCodePromise;
  }

  async function updateCart(params) {
    if (updatePromise) {
      await updatePromise;
    }

    let resolveFn, rejectFn;
    updatePromise = new Promise((resolve, reject) => {
      resolveFn = resolve;
      rejectFn = reject;
    });

    (async () => {
      let cart = null,
        body = {};

      if ('codes' in params) {
        body.discount = params.codes ?? '';
      }

      if ('attrib' in params || 'disc_tokens' in params) {
        body.attributes = {
          ...(body.attributes ?? {}),
          ...('attrib' in params && { disc_cds: params.attrib ?? '' }),
          ...('disc_tokens' in params && { disc_tokens: params.disc_tokens ?? '' }),
        };
      }

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(body),
        });
        if (!response.ok) {
          throw new Error(`Netzwerk meldet Fehler. Status: ${response.status}, Status-Text: ${response.statusText}`);
        }

        cart = await response.json();
        lastUpdateCart = cart;

        if (params.reInit !== false) {
          let { cartLevelCodes, productLevelCodes, hasBook, hasDeposit, applicableCodes } = analyzeCart(cart);
          cartLevelCode = cartLevelCodes.at(-1) ?? null;
          productLevelCode = productLevelCodes.at(-1) ?? null;
          productLevelType = productLevelCode ? (inflCodes.has(productLevelCode) ? 'infl' : 'pub') : null;
          if (orderDiscountExclusions && cartLevelCode && (hasBook || hasDeposit) && !orderCodes.has(cartLevelCode)) {
            cartLevelCode = null;
          }
          allCodes = [cartLevelCode, productLevelCode].filter(Boolean).sort();
          appliedCodes = new Set(applicableCodes);
          const { disc_cds, disc_tokens } = getCartAttributes(cart);
          discountCodesAttribute = disc_cds ?? '';
          discountTokens = disc_tokens?.split(',') ?? [];

          try {
            await calc.init(cart);
          } catch (error) {
            console.error(error);
            rejectFn(new Error('Fehler beim Initialisieren auf calc-Ebene'));
            return;
          }

          resolveFn(true);
        } else {
          resolveFn(cart);
        }
      } catch (error) {
        console.error('Fehler beim Update des Warenkorbs:', error);
        rejectFn(error);
      } finally {
        updatePromise = null;
      }
    })();

    return updatePromise;
  }

  function analyzeCart(cart) {
    let productLevelCodes = [];
    let cartLevelCodes = [];
    let hasBook = false;
    let hasDeposit = false;
    const applicableCodes = [];

    for (const { code, applicable } of cart.discount_codes ?? []) {
      const lower = code.toLowerCase();
      if (applicable) {
        applicableCodes.push(lower);
      }
      if (campaignCodes.has(lower) || appCodes.has(lower) || inflCodes.has(lower)) {
        productLevelCodes.push(lower);
      } else if (orderCodes.has(lower)) {
        // Unterhalb seiner Bedingung erzeugt er keine Warenkorb-Anwendung; die zweite Schleife sieht ihn nicht.
        cartLevelCodes.push(lower);
      }
    }

    for (let appl of cart.cart_level_discount_applications ?? []) {
      if (appl.discount_application) {
        appl = appl.discount_application;
      }
      if (appl.type !== 'discount_code') continue;

      const code = appl.title.toLowerCase();

      if (appl.total_allocated_amount == 0 && (campaignCodes.has(code) || inflCodes.has(code))) {
        productLevelCodes.push(code);
      } else if (!campaignCodes.has(code) && !inflCodes.has(code) && !appCodes.has(code)) {
        cartLevelCodes.push(code);
      }
    }

    for (const item of cart.items ?? []) {
      if (item.product_type === 'Book') hasBook = true;
      if (item.product_type === 'Deposit') hasDeposit = true;

      productLevelCodes.push(
        ...item.line_level_discount_allocations
          .filter((alloc) => alloc.discount_application.type === 'discount_code' && alloc.amount > 0)
          .map((alloc) => alloc.discount_application.title.toLowerCase()),
      );
    }

    productLevelCodes = [...new Set(productLevelCodes)];
    cartLevelCodes = [...new Set(cartLevelCodes)];

    // Anwendbar, aber ohne Allocation im Warenkorb: wirkt ausserhalb des Warenkorbs, also Versand.
    // Nur Versandcodes melden hier applicable == true, auch unterhalb ihres Mindestbestellwerts.
    for (const { code, applicable } of cart.discount_codes ?? []) {
      const lower = code.toLowerCase();
      if (!applicable) continue;
      if (!productLevelCodes.includes(lower) && !cartLevelCodes.includes(lower)) {
        cartLevelCodes.push(lower);
      }
    }

    return { productLevelCodes, cartLevelCodes, hasBook, hasDeposit, applicableCodes };
  }

  function refreshCodes(cart) {
    const prevAllCodes = allCodes.map((c) => c);
    const { cartLevelCodes, productLevelCodes, applicableCodes } = analyzeCart(cart);
    cartLevelCode = cartLevelCodes.at(-1) ?? null;
    productLevelCode = productLevelCodes.at(-1) ?? null;
    productLevelType = productLevelCode ? (inflCodes.has(productLevelCode) ? 'infl' : 'pub') : null;
    allCodes = [cartLevelCode, productLevelCode].filter(Boolean).sort();
    appliedCodes = new Set(applicableCodes);
    // if (!arraysEqual(prevAllCodes, allCodes)) {
    //   window.dispatchEvent(new CustomEvent('co2.codes.updated', { detail: { allCodes, cartLevelCode, productLevelCode } }));
    // }
  }

  function applicabilityOf(code) {
    return appliedCodes.has(code) ? 'applied' : 'pending';
  }

  // Ergebnis für alle Konsumenten, immer aus dem abgeschlossenen Zustand, nie aus der Probe in addCode.
  function buildOutcome({ ok, error_code = null, entered = null, previousCodes = [] }) {
    const codes = allCodes ?? [];
    const previous = [...new Set((previousCodes ?? []).map((code) => code.toLowerCase()))];
    const isOwnOrder = !!entered && codes.includes(entered) && orderCodes.has(entered);

    return {
      ok,
      ...(!ok && error_code ? { error_code } : {}),
      entered,
      enteredStatus: isOwnOrder ? applicabilityOf(entered) : null,
      applied: codes.filter((code) => appliedCodes.has(code)),
      pending: codes.filter((code) => !appliedCodes.has(code)),
      displaced: previous.filter((code) => !codes.includes(code)),
    };
  }

  function getCartAttributes(cart) {
    return {
      disc_cds: cart?.attributes?.disc_cds?.toLowerCase() ?? null,
      disc_tokens: cart?.attributes?.disc_tokens ?? null,
    };
  }

  function getDiscountCodesAttribute(codes) {
    return codes
      .map((code) => {
        const type = inflCodes.has(code) ? 'infl' : 'pub';
        return `${code}:${type}`;
      })
      .sort()
      .join(',');
  }

  function arraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((val, i) => val === arr2[i]);
  }

  function isAlphanumeric(str) {
    if (typeof str !== 'string' || !str) {
      return false;
    }
    return /^[\p{Script=Latin}\p{N}.\-_]+$/u.test(str);
  }

  function cleanAndValidateStrings(arr) {
    if (!Array.isArray(arr)) {
      return [];
    }

    return arr
      .filter((str) => isAlphanumeric(str))
      .map((str) => str.toLowerCase().trim())
      .filter((str) => str !== '');
  }

  function base64ToUtf8(base64Str) {
    const binaryString = atob(base64Str);
    const utf8Bytes = Uint8Array.from(binaryString, (char) => char.charCodeAt(0));
    const utf8String = new TextDecoder().decode(utf8Bytes);
    return utf8String;
  }

  function equal(code1, code2) {
    if (!code1 && !code2) {
      return true;
    }
    if (!code1 || !code2) {
      return false;
    }
    if (typeof code1 === 'string' && typeof code2 === 'string') {
      return code1 === code2;
    }
    return false;
  }

  function calculate(price, calc, discPerc, discAmt, q) {
    if (calc == 'perc') {
      if (q == 0) {
        return 0;
      } else {
        return round((price / q) * (1.0 - discPerc / 100.0)) * q;
      }
    } else {
      return Math.max(round(price - q * discAmt * 100.0), 0);
    }
  }

  function round(value) {
    return Math.round(value + 1e-9);
  }

  function numericId(id) {
    if (!(typeof id === 'string')) {
      return 0;
    }
    const num = parseFloat(id.split('/').pop());
    return typeof num === 'number' && !Number.isNaN(num) ? num : 0;
  }

  function serverTime() {
    return new Date(Date.now() + timeDiff);
  }

  function productAvailable(product) {
    if (!product.availableForSale || product.tags.includes('dgs-soldout')) {
      return false;
    }
    if (product.soldout_markets === null) {
      return true;
    }
    return !JSON.parse(product.soldout_markets.value).includes(marketHandleId);
  }

  function variantAvailable(variant) {
    if (!variant.availableForSale) {
      return false;
    }
    for (const variantMarket of variant.metafields) {
      if (variantMarket?.key === 'soldout-markets' && JSON.parse(variantMarket.value).includes(marketHandleId)) {
        return false;
      }
    }
    return true;
  }

  function variantUnitsPerItem(variant) {
    for (const variantMetafield of variant.metafields) {
      if (variantMetafield?.key === 'units_per_item') {
        const units = parseInt(variantMetafield.value);
        return isNaN(units) || units < 1 ? null : units;
      }
    }
    return null;
  }

  // Aufgelöste Pfand-Variant-ID pro Variante (mn_deposit.variant_item, variant_reference)
  function variantDepositVariantId(variant) {
    for (const variantMetafield of variant.metafields) {
      if (variantMetafield?.key === 'variant_item' && variantMetafield.value) {
        const id = numericId(variantMetafield.value);
        return id || null;
      }
    }
    return null;
  }

  function getCookieValue(cookieName) {
    let cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      if (cookie.startsWith(cookieName + '=')) {
        return cookie.substring((cookieName + '=').length);
      }
    }
    return null;
  }

  function deleteCookie(cookieName) {
    document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }

  window.addEventListener('DOMContentLoaded', ensurePromises);

  return {
    getDiscountCode: async () => {
      await ensurePromises();
      return productLevelCode ?? false;
    },
    getDiscountType: async () => {
      await ensurePromises();
      return productLevelType ?? false;
    },
    getProductLevelCode: async () => {
      await ensurePromises();
      return productLevelCode ?? false;
    },
    getCartLevelCode: async () => {
      await ensurePromises();
      return cartLevelCode ?? false;
    },
    getAllCodes: async () => {
      await ensurePromises();
      return allCodes;
    },
    setDiscountCode: async (code) => {
      if (!isAlphanumeric(code)) {
        return false;
      }
      await ensurePromises();
      code = code.toLowerCase();
      let attrib = `${code}:pub`;
      if (inflCodes.has(code)) {
        attrib = `${code}:infl`;
      }
      await updateCart({ codes: code, attrib });
      return code === productLevelCode;
    },
    addDiscountCode: async (code) => {
      await ensurePromises();
      const lower = typeof code === 'string' ? code.toLowerCase() : null;
      if (!isAlphanumeric(code)) {
        return buildOutcome({ ok: false, error_code: 'INVALID', entered: lower, previousCodes: allCodes });
      }
      if (allCodes.includes(lower)) {
        return buildOutcome({ ok: true, entered: lower, previousCodes: allCodes });
      }
      return await addCode(lower);
    },
    isOwnOrderCode: async (code) => {
      await ensurePromises();
      return typeof code === 'string' && orderCodes.has(code.toLowerCase());
    },
    removeDiscountCode: async (code) => {
      await ensurePromises();
      if (!code) {
        return await updateCart({ codes: null, attrib: null });
      }
      code = code.toLowerCase();
      if (!allCodes.includes(code)) {
        return true;
      }
      const codes = allCodes.filter((c) => c !== code);
      const attrib = getDiscountCodesAttribute(codes);
      return await updateCart({ codes: codes.join(','), attrib });
    },
    getDiscountTokens: async () => {
      await ensurePromises();
      return discountTokens.length == 0 ? false : discountTokens;
    },
    setDiscountTokens: async (tokens) => {
      tokens = cleanAndValidateStrings(tokens);
      if (tokens.length == 0) {
        return false;
      }
      await ensurePromises();
      return await updateCart({ disc_tokens: tokens.join(',') });
    },
    removeDiscountTokens: async () => {
      await ensurePromises();
      return await updateCart({ disc_tokens: null });
    },
    itemDiscount: async (
      product_id,
      variant_id,
      tags,
      sub_total,
      quantity = 1,
      variantTags = [],
      sale_price = false,
      subscription = false,
    ) => {
      await ensurePromises();
      const line = {
        product_id,
        variant_id,
        tags: new Set(tags.map((tag) => tag.toLowerCase())),
        variantTags: new Set(variantTags.map((tag) => tag.toLowerCase())),
        sub_total,
        quantity,
        subscription,
        sale_price: !!sale_price,
      };
      const discount = calc.campaignDiscount(line, calc.discRules(), calc.discExTags(), true);
      discount.condPerc = calc.maxCondDiscount(line);
      return discount;
    },
    itemDiscountFull: async (
      product_id,
      variant_id,
      tags,
      sub_total,
      quantity = 1,
      variantTags = [],
      sale_price = false,
      subscription = false,
    ) => {
      await ensurePromises();
      const line = {
        product_id,
        variant_id,
        tags: new Set(tags.map((tag) => tag.toLowerCase())),
        variantTags: new Set(variantTags.map((tag) => tag.toLowerCase())),
        sub_total,
        quantity,
        subscription,
        sale_price: !!sale_price,
      };
      let discount = calc.campaignDiscount(line, calc.discRules(), calc.discExTags(), true);
      const condDiscount = calc.condDiscount(line, discount.discPrice);
      if (condDiscount.discPrice < discount.discPrice) {
        discount = condDiscount;
      } else if (!settings.fp_need_cond_disc_exclusion) {
        const freeProductDiscount = calc.freeProductDiscount(line);
        if (freeProductDiscount.discPerc == 100) {
          discount = freeProductDiscount;
        }
      }
      discount.condPerc = calc.maxCondDiscount(line);
      return discount;
    },
    freeProductThresholds: async () => {
      await ensurePromises();
      if (calc.suppressFreeProducts()) {
        return [];
      }
      return calc.thresholds();
    },
    freeProductKeys: async () => {
      await ensurePromises();
      if (calc.suppressFreeProducts()) {
        return [];
      }
      return calc.freeProductKeys();
    },
    unredeemedfreeProducts: async () => {
      await ensurePromises();
      if (calc.suppressFreeProducts()) {
        return [];
      }
      return calc.unredeemed();
    },
    nextFreeProducts: async () => {
      await ensurePromises();
      if (calc.suppressFreeProducts()) {
        return false;
      }
      return calc.nextFreeProducts();
    },
    freeProductData: async () => {
      await ensurePromises();
      if (calc.suppressFreeProducts()) {
        return [];
      }
      return calc.freeProductData();
    },
    conditionalDiscounts: async (
      product_id,
      variant_id,
      tags,
      variantTags = [],
      sale_price = false,
      subscription = false,
    ) => {
      await ensurePromises();
      const line = {
        product_id,
        variant_id,
        tags: new Set(tags.map((tag) => tag.toLowerCase())),
        variantTags: new Set(variantTags.map((tag) => tag.toLowerCase())),
        subscription,
        sale_price: !!sale_price,
      };
      const condDiscs = calc.conditionalDiscounts(line);
      for (const disc of condDiscs.condition_applies) {
        if (condDiscs.rule_applies.includes(disc) && disc.cond_minimum == 'quant' && disc.multi_apply == 'unlimited') {
          disc.kind = 'tiered_pricing';
        }
      }
      return condDiscs;
    },
    shippingData: async (country, customerTags) => {
      await ensurePromises();
      return calc.shippingData(country.toUpperCase(), new Set(customerTags.map((tag) => tag.toLowerCase())));
    },
    thresholdAvailabilities: async (getAll = false) => {
      await ensurePromises();
      return calc.thresholdAvailabilities(getAll);
    },
    bundleDataForCollectionProduct: async (bundleId) => {
      await bdl.ensureBundlePromises();
      return bdl.bundleDataForCollectionProduct(bundleId);
    },
    standardDiscountCode: async () => {
      await ensurePromises();
      return calc.standardDiscountCode() ? calc.standardDiscountCode().toLowerCase() : false;
    },
    standardDiscount: async (
      product_id,
      variant_id,
      tags,
      sub_total,
      quantity = 1,
      variantTags = [],
      sale_price = false,
      subscription = false,
    ) => {
      await ensurePromises();
      const line = {
        product_id,
        variant_id,
        tags: new Set(tags.map((tag) => tag.toLowerCase())),
        variantTags: new Set(variantTags.map((tag) => tag.toLowerCase())),
        sub_total,
        quantity,
        subscription,
        sale_price: !!sale_price,
      };
      let discount = calc.campaignDiscount(line, calc.standardDiscRules(), calc.standardExTags(), false);
      const condDiscount = calc.condDiscount(line, discount.discPrice, calc.standardCondDiscRules());
      if (condDiscount.discPrice < discount.discPrice) {
        discount = condDiscount;
      }
      return discount;
    },
    currentCampaignCodes: async () => {
      await ensurePromises();
      const { infl_codes = false, disc_codes = [] } = calc.standardProductDiscounts()[0] || {};
      return { infl_codes, disc_codes };
    },
    isCurrentCampaignCode: async () => {
      await ensurePromises();
      if (!productLevelCode) {
        return undefined;
      }
      const { infl_codes = false, disc_codes = [] } = calc.standardProductDiscounts()[0] || {};
      if ((infl_codes && productLevelType === 'infl') || disc_codes.includes(productLevelCode)) {
        return true;
      }
      return false;
    },
    productIncluded: async (productId, selectedCountryCode) => {
      const gid = `gid://shopify/Product/${productId}`;
      const query = `
        query Products($ids: [ID!]!, $country: CountryCode) @inContext(country: $country) {
          nodes(ids: $ids) {
            ... on Product {
              id
            }
          }
        }`;
      const variables = {
        ids: [gid],
        country: selectedCountryCode.toUpperCase(),
      };
      try {
        const response = await clientFetchWithRetry(query, { variables });
        if (!response.ok) {
          console.warn('Fehler beim Laden des Produkts zur Marktprüfung:', response.status);
          return false;
        }
        const json = await response.json();
        const productNode = json?.data?.nodes?.[0];
        return productNode !== null && productNode?.id !== null;
      } catch (e) {
        console.warn('productIncluded() schlug fehl', e);
        return false;
      }
    },
    setCartMetafield: async (namespace, key, value, type = 'single_line_text_field') => {
      await ensureInit();
      try {
        const ownerId = `gid://shopify/Cart/${cartToken}`;
        const query = `
          mutation SetCartMetafield {
            cartMetafieldsSet(
              metafields: [{
                ownerId: "${ownerId}",
                key: "${namespace}.${key}",
                value: """${value}""",
                type: "${type}"
              }]
            ) {
              metafields {
                id
                namespace
                key
                value
              }
              userErrors {
                field
                message
              }
            }
          }
        `;

        const response = await clientFetchWithRetry(query);
        const { data, errors } = await response.json();

        if (errors?.length) {
          console.error('[co2.setCartMetafield] GraphQL-Fehler:', errors);
          return null;
        }

        const result = data?.cartMetafieldsSet;
        if (result?.userErrors?.length) {
          console.error('[co2.setCartMetafield] Shopify-Fehler:', result.userErrors);
          return null;
        }

        console.info('[co2.setCartMetafield] Erfolgreich gesetzt:', result?.metafields);
        return result?.metafields || null;
      } catch (err) {
        console.error('[co2.setCartMetafield] Fehler:', err);
        return null;
      }
    },
    addDepositItems: async function (additions) {
      await ensureInit();

      if (!additions?.length) return { ok: true, added: 0 };

      if (!cartToken) {
        throw new Error('[co2.addDepositItems] cartToken fehlt');
      }

      const cartId = `gid://shopify/Cart/${cartToken}`;

      // ---- GraphQL ----
      const GQL_CART_QUERY = `
        query Cart($id: ID!) {
          cart(id: $id) {
            id
            lines(first: 250) {
              nodes { 
                id 
              }
            }
          }
        }
      `;

      const GQL_CART_LINES_ADD = `
        mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
          cartLinesAdd(cartId: $cartId, lines: $lines) {
            userErrors { 
              field 
              message 
            }
            cart { 
             id 
            }
          }
        }
      `;

      try {
        let variables, response, json;

        // Storefront-Cart lesen
        variables = { id: cartId };
        response = await clientFetchWithRetry(GQL_CART_QUERY, { variables });
        if (!response.ok) {
          console.error('[co2.addDepositItems] Cart-Query HTTP-Fehler:', response.status, response.statusText);
          return { ok: false, added: 0, httpStatus: response.status };
        }

        json = await response.json();
        if (json.errors?.length) {
          console.error('[co2.addDepositItems] Cart-Query GraphQL errors:', json.errors);
          return { ok: false, added: 0, errors: json.errors };
        }

        const nodes = json?.data?.cart?.lines?.nodes || [];

        // Payload für cartLinesAdd bauen (positionsbasiert)
        const sfLines = [];
        for (const add of additions) {
          const parentSf = nodes[add.anchorAjaxIndex];
          if (!parentSf) {
            console.warn('[co2.addDepositItems] Kein Parent an Index:', add.anchorAjaxIndex, add);
            continue;
          }
          if (!add.depositVariantId) {
            console.warn('[co2.addDepositItems] Kein depositVariantId für Addition:', add);
            continue;
          }
          sfLines.push({
            quantity: add.quantity,
            merchandiseId: `gid://shopify/ProductVariant/${add.depositVariantId}`,
            parent: { lineId: parentSf.id },
            attributes: [
              { key: '_group', value: add.group },
              { key: '_is_deposit', value: 'true' },
            ],
          });
        }

        if (sfLines.length === 0) {
          return { ok: true, added: 0, skipped: additions.length };
        }

        // cartLinesAdd ausführen
        variables = { cartId, lines: sfLines };
        response = await clientFetchWithRetry(GQL_CART_LINES_ADD, { variables });
        if (!response.ok) {
          console.error('[co2.addDepositItems] cartLinesAdd HTTP-Fehler:', response.status, response.statusText);
          return { ok: false, added: 0, httpStatus: response.status };
        }

        json = await response.json();
        if (json.errors?.length) {
          console.error('[co2.addDepositItems] cartLinesAdd GraphQL errors:', json.errors);
          return { ok: false, added: 0, errors: json.errors };
        }

        const result = json?.data?.cartLinesAdd;
        const userErrors = result?.userErrors || [];
        if (userErrors.length) {
          console.error('[co2.addDepositItems] cartLinesAdd userErrors:', userErrors);
        }

        return {
          ok: userErrors.length === 0,
          added: sfLines.length,
          userErrors,
        };
      } catch (err) {
        console.error('[co2.addDepositItems] Fehler:', err);
        throw err;
      }
    },
    updateDepositProperties: async function (updatesWithIndex) {
      await ensureInit();

      if (!updatesWithIndex?.length) {
        return { ok: true, updated: 0, skipped: 0 };
      }

      if (!cartToken) {
        console.error('[co2.updateDepositProperties] cartToken fehlt');
        return { ok: false, updated: 0, skipped: updatesWithIndex.length };
      }

      const cartId = `gid://shopify/Cart/${cartToken}`;

      const GQL_CART_QUERY = `
        query Cart($id: ID!) {
          cart(id: $id) {
            lines(first: 250) {
              nodes { id }
            }
          }
        }
      `;

      const GQL_CART_LINES_UPDATE = `
        mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
          cartLinesUpdate(cartId: $cartId, lines: $lines) {
            userErrors { field message }
          }
        }
      `;

      try {
        // 1) Storefront-Cart holen
        let response = await clientFetchWithRetry(GQL_CART_QUERY, { variables: { id: cartId } });

        if (!response.ok) {
          console.error('[co2.updateDepositProperties] HTTP-Fehler Cart Query:', response.status);
          return { ok: false, updated: 0, skipped: updatesWithIndex.length };
        }

        let json = await response.json();

        if (json.errors?.length) {
          console.error('[co2.updateDepositProperties] GraphQL errors:', json.errors);
          return { ok: false, updated: 0, skipped: updatesWithIndex.length };
        }

        const nodes = json?.data?.cart?.lines?.nodes || [];
        if (!nodes.length) {
          console.error('[co2.updateDepositProperties] Keine Cart-Lines gefunden');
          return { ok: false, updated: 0, skipped: updatesWithIndex.length };
        }

        // 2) Mapping + Payload bauen
        const lines = [];
        let skipped = 0;

        for (const entry of updatesWithIndex) {
          const { ajaxIndex, properties } = entry;

          if (!Number.isInteger(ajaxIndex) || ajaxIndex < 0 || ajaxIndex >= nodes.length) {
            console.error('[co2.updateDepositProperties] Ungültiger ajaxIndex:', ajaxIndex);
            skipped++;
            continue;
          }

          const sfLine = nodes[ajaxIndex];
          if (!sfLine?.id) {
            console.error('[co2.updateDepositProperties] Keine Storefront-Line-ID für Index:', ajaxIndex);
            skipped++;
            continue;
          }

          const attributes = Object.entries(properties).map(([k, v]) => ({
            key: k,
            value: String(v),
          }));

          lines.push({ id: sfLine.id, attributes });
        }

        if (!lines.length) {
          return { ok: true, updated: 0, skipped: updatesWithIndex.length };
        }

        // 3) cartLinesUpdate ausführen
        response = await clientFetchWithRetry(GQL_CART_LINES_UPDATE, {
          variables: { cartId, lines },
        });

        if (!response.ok) {
          console.error('[co2.updateDepositProperties] HTTP-Fehler bei cartLinesUpdate:', response.status);
          return { ok: false, updated: 0, skipped: updatesWithIndex.length };
        }

        json = await response.json();

        if (json.errors?.length) {
          console.error('[co2.updateDepositProperties] GraphQL errors:', json.errors);
          return { ok: false, updated: 0, skipped };
        }

        const userErrors = json?.data?.cartLinesUpdate?.userErrors || [];
        if (userErrors.length) {
          console.error('[co2.updateDepositProperties] userErrors:', userErrors);
        }

        return { ok: userErrors.length === 0, updated: lines.length, skipped, userErrors };
      } catch (err) {
        console.error('[co2.updateDepositProperties] Exception:', err);
        return { ok: false, updated: 0, skipped: updatesWithIndex.length };
      }
    },
    updateDepositQuantities: async function (updates, ajaxCart) {
      await ensureInit();

      const keys = Object.keys(updates || {});
      if (!keys.length) return { ok: true, updated: 0, skipped: 0 };

      if (!cartToken) {
        console.error('[co2.updateDepositQuantities] cartToken fehlt');
        return { ok: false, updated: 0, skipped: keys.length, reason: 'missing_cart_token' };
      }

      const cartId = `gid://shopify/Cart/${cartToken}`;

      const GQL_CART_QUERY = `
        query Cart($id: ID!) {
          cart(id: $id) {
            id
            lines(first: 250) {
              nodes {
                id
              }
            }
          }
        }
      `;

      const GQL_CART_LINES_UPDATE = `
        mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
          cartLinesUpdate(cartId: $cartId, lines: $lines) {
            userErrors {
              field
              message
            }
            cart {
              id
            }
          }
        }
      `;

      try {
        // 1) Storefront-Cart lesen
        let variables = { id: cartId };
        let response = await clientFetchWithRetry(GQL_CART_QUERY, { variables });

        if (!response.ok) {
          console.error('[co2.updateDepositQuantities] Cart-Query HTTP-Fehler:', response.status, response.statusText);
          return { ok: false, updated: 0, skipped: keys.length, httpStatus: response.status };
        }

        const json = await response.json();
        if (json.errors?.length) {
          console.error('[co2.updateDepositQuantities] Cart-Query GraphQL errors:', json.errors);
          return { ok: false, updated: 0, skipped: keys.length, errors: json.errors };
        }

        const nodes = json?.data?.cart?.lines?.nodes || [];
        const items = ajaxCart?.items || [];

        // 2) Mapping: ajaxCart.items[i].key -> nodes[i].id
        const linesPayload = [];

        for (const key of keys) {
          const newQty = Number(updates[key]);
          if (!Number.isFinite(newQty) || newQty < 0) {
            console.warn('[co2.updateDepositQuantities] Ungültige quantity, skippe:', key, updates[key]);
            continue;
          }

          const ajaxIndex = items.findIndex((i) => i.key === key);
          if (ajaxIndex < 0) {
            console.warn('[co2.updateDepositQuantities] Kein Ajax-Item für Key gefunden:', key);
            continue;
          }

          const sfLine = nodes[ajaxIndex];
          if (!sfLine) {
            console.warn('[co2.updateDepositQuantities] Kein Storefront-Line an Index:', ajaxIndex, 'für Key:', key);
            continue;
          }

          linesPayload.push({
            id: sfLine.id,
            quantity: newQty,
          });
        }

        if (!linesPayload.length) {
          return { ok: true, updated: 0, skipped: keys.length };
        }

        // 3) cartLinesUpdate ausführen
        variables = { cartId, lines: linesPayload };
        response = await clientFetchWithRetry(GQL_CART_LINES_UPDATE, { variables });

        if (!response.ok) {
          console.error(
            '[co2.updateDepositQuantities] cartLinesUpdate HTTP-Fehler:',
            response.status,
            response.statusText,
          );
          return { ok: false, updated: 0, skipped: keys.length, httpStatus: response.status };
        }

        const updJson = await response.json();
        if (updJson.errors?.length) {
          console.error('[co2.updateDepositQuantities] cartLinesUpdate GraphQL errors:', updJson.errors);
          return { ok: false, updated: 0, skipped: keys.length, errors: updJson.errors };
        }

        const result = updJson?.data?.cartLinesUpdate;
        const userErrors = result?.userErrors || [];

        if (userErrors.length) {
          console.error('[co2.updateDepositQuantities] cartLinesUpdate userErrors:', userErrors);
        }

        return {
          ok: userErrors.length === 0,
          updated: linesPayload.length,
          skipped: keys.length - linesPayload.length,
          userErrors,
        };
      } catch (err) {
        console.error('[co2.updateDepositQuantities] Fehler:', err);
        return { ok: false, updated: 0, skipped: keys.length, error: String(err) };
      }
    },
  };
})();
